'use strict';

var classnames = require('classnames');

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = ".Z6OfUI2sH34- {\n  fill: var(--color-icon);\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.gKAiKduA7YU- {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.ZJ3jy3YYT0U- {\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n\n.KkS1FWxLioI- {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n._7KU7gAbdYjw- {\n  -webkit-transform: rotate(0deg);\n          transform: rotate(0deg);\n}\n\n._30zSLR5-c7Y- {\n  -webkit-transform: scaleY(-1);\n          transform: scaleY(-1);\n}\n\n.yAELOSHgxqc-,\n.qa4B8AiSlto-,\n.hbCRGVLdJIQ-,\n.EaUN2-mTxSg- {\n  fill: var(--color-client);\n}\n\n.RGq9MkROGD4-,\n.HEQNHAE0p-I- {\n  fill: var(--color-job);\n}\n\n.Zb76NOvfQE0-,\n._6dIqIl8AA3A- {\n  fill: var(--color-lime);\n}\n\n.F7wr-sw9rrg- {\n  fill: var(--color-yellow);\n}\n\n.F6zONsHKokY- {\n  fill: var(--color-quote);\n}\n\n.nQ6rfm0H2tw- {\n  fill: var(--color-request);\n}\n\n.mPUyx1eUPvw- {\n  fill: var(--color-navy);\n}\n\n.tt6WEoo6nnk-,\n.h0MfBU9MDJo-,\n.M3WS8MGmgrk- {\n  fill: var(--color-destructive);\n}\n\n.S4fBuUx-A70- {\n  fill: var(--color-success);\n}\n\n.OIRfCccq1-k- {\n  fill: var(--color-lightBlue);\n}\n\n.pfKSCbzfh1k-,\n.FcVm5FDNmvk-,\n.FeAQShl60CI-,\n.YYWX3pQ4lks- {\n  fill: var(--color-invoice);\n}\n\n.FT82IKET9lI- {\n  fill: var(--color-critical);\n}\n\n._0cmyJb6bEgU-,\n.wF8GKbfMvKI- {\n  fill: var(--color-orange);\n}\n\n.DCpxHyIHNPE- {\n  fill: var(--color-lightBlue);\n}\n\n/* non-Atlantis colors to match brand colors of these file-types */\n\n._4YZ9L5eggeE- {\n  fill: rgb(31, 115, 71);\n}\n\n._70PQ4xIy0cE- {\n  fill: rgb(195, 27, 0);\n}\n\n.vmj7sbHJicU- {\n  fill: rgb(41, 86, 154);\n}\n\n.TWv4VW54z4o- {\n  -webkit-animation-duration: 5s;\n          animation-duration: 5s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-name: w3VStbNDR2k-;\n          animation-name: w3VStbNDR2k-;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n}\n\n@-webkit-keyframes w3VStbNDR2k- {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes w3VStbNDR2k- {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n";
var styles = {"icon":"Z6OfUI2sH34-","longArrowUp":"gKAiKduA7YU-","longArrowDown":"ZJ3jy3YYT0U-","longArrowRight":"KkS1FWxLioI-","longArrowLeft":"_7KU7gAbdYjw-","thumbsDown":"_30zSLR5-c7Y-","person":"yAELOSHgxqc-","clients":"qa4B8AiSlto-","company":"hbCRGVLdJIQ-","property":"EaUN2-mTxSg-","job":"RGq9MkROGD4-","jobOnHold":"HEQNHAE0p-I-","visit":"Zb76NOvfQE0-","moveVisits":"_6dIqIl8AA3A-","event":"F7wr-sw9rrg-","quote":"F6zONsHKokY-","request":"nQ6rfm0H2tw-","task":"mPUyx1eUPvw-","userUnassigned":"tt6WEoo6nnk-","reminder":"h0MfBU9MDJo-","trash":"M3WS8MGmgrk-","checkmark":"S4fBuUx-A70-","timer":"OIRfCccq1-k-","invoice":"pfKSCbzfh1k-","invoiceLater":"FcVm5FDNmvk-","sendInvoice":"FeAQShl60CI-","paidInvoice":"YYWX3pQ4lks-","badInvoice":"FT82IKET9lI-","payment":"_0cmyJb6bEgU-","expense":"wF8GKbfMvKI-","video":"DCpxHyIHNPE-","excel":"_4YZ9L5eggeE-","pdf":"_70PQ4xIy0cE-","word":"vmj7sbHJicU-","runningTimer":"TWv4VW54z4o-","spinning":"w3VStbNDR2k-"};
styleInject(css_248z$2);

var css_248z$1 = ".qm8vYTlCGG4- {\n  width: var(--base-unit);\n  height: var(--base-unit);\n}\n\n.TphtDHcwxDc- {\n  width: calc(var(--base-unit) * 1.5);\n  height: calc(var(--base-unit) * 1.5);\n}\n\n.xZ6Jnv-7uXc- {\n  width: calc(var(--base-unit) * 2);\n  height: calc(var(--base-unit) * 2);\n}\n";
var sizes = {"small":"qm8vYTlCGG4-","base":"TphtDHcwxDc-","large":"xZ6Jnv-7uXc-"};
styleInject(css_248z$1);

var css_248z = ".TpLksR41OM0- {\n  fill: var(--color-white);\n}\n\n._51WS98pPpKY- {\n  fill: var(--color-grey);\n}\n\n.eenEpNGpzfA- {\n  fill: var(--color-greyBlue);\n}\n\n.vhEzXPEfZyQ- {\n  fill: var(--color-greyBlue--dark);\n}\n\n.pvDSIqHkL1g- {\n  fill: var(--color-greyBlue--lighter);\n}\n\n.f80PxizYkj4- {\n  fill: var(--color-blue);\n}\n\n.O7JR2KGCfcg- {\n  fill: var(--color-lightBlue);\n}\n\n.kBAjqBTXEsI- {\n  fill: var(--color-green);\n}\n\n.wNm-EF7M4g0- {\n  fill: var(--color-yellow);\n}\n\n.RQVWfFQDPu0- {\n  fill: var(--color-red);\n}\n\n.xl38E3cTBRo- {\n  fill: var(--color-navy);\n}\n\n.Y0tpTN7mt2M- {\n  fill: var(--color-orange);\n}\n\n.haFR6Zwp-a4- {\n  fill: var(--color-interactive);\n}\n\n.uZjlqe-em2E- {\n  fill: var(--color-interactive--hover);\n}\n\n.pv3CFbTk-Mg- {\n  fill: var(--color-destructive);\n}\n\n.E5Yz9BNVLPg- {\n  fill: var(--color-destructive--hover);\n}\n\n.Ag8mttBCQtU- {\n  fill: var(--color-interactive--subtle);\n}\n\n.XY4qV0-e3DM- {\n  fill: var(--color-interactive--subtle--hover);\n}\n\n.ruwXWGEJXS4- {\n  fill: var(--color-disabled);\n}\n\n.OinDbMeLOso- {\n  fill: var(--color-disabled--secondary);\n}\n\n.JwWv29JWwzE- {\n  fill: var(--color-focus);\n}\n\n.avM4gudjYeg- {\n  fill: var(--color-critical);\n}\n\n.amAXqNTFYcg- {\n  fill: var(--color-critical--surface);\n}\n\n.omSKoausvXA- {\n  fill: var(--color-critical--onSurface);\n}\n\n.aQIlKXSkyDM- {\n  fill: var(--color-warning);\n}\n\n.hvzZjM9cQns- {\n  fill: var(--color-warning--surface);\n}\n\n.M1oIoiDS82s- {\n  fill: var(--color-warning--onSurface);\n}\n\n.HavlDN2ZD-k- {\n  fill: var(--color-success);\n}\n\n.YCX5CYqdHdU- {\n  fill: var(--color-success--surface);\n}\n\n.yDtFAzbc4N0- {\n  fill: var(--color-success--onSurface);\n}\n\n.ItL-7gRcsBo- {\n  fill: var(--color-informative);\n}\n\n._1kkDnQDmX54- {\n  fill: var(--color-informative--surface);\n}\n\n.C1HyOUrN-2U- {\n  fill: var(--color-informative--onSurface);\n}\n\n.qV6UDI0M-NE- {\n  fill: var(--color-inactive);\n}\n\n._3-xvTk8wOcc- {\n  fill: var(--color-inactive--surface);\n}\n\n.ZPvBgU-Flrw- {\n  fill: var(--color-inactive--onSurface);\n}\n\n._4QMQd-zVb70- {\n  fill: var(--color-heading);\n}\n\n.dbTNEuj0Xmw- {\n  fill: var(--color-text);\n}\n\n.FNvqhTrxwHc- {\n  fill: var(--color-text--secondary);\n}\n\n.fgWgyrLt8xI- {\n  fill: var(--color-text--reverse);\n}\n\n.JfcuaSm1ZSk- {\n  fill: var(--color-text--reverse--secondary);\n}\n\n.hQLb9vztL-Q- {\n  fill: var(--color-surface);\n}\n\n.epshb9WJQDU- {\n  fill: var(--color-surface--hover);\n}\n\n.IcsOosya54c- {\n  fill: var(--color-surface--active);\n}\n\n.zXzW4ql9U-I- {\n  fill: var(--color-surface--background);\n}\n\n.dbzz7qC7vHY- {\n  fill: var(--color-surface--reverse);\n}\n\n.wBuQiZfdPrI- {\n  fill: var(--color-brand);\n}\n\n.TEOLQtdrGAU- {\n  fill: var(--color-brand--highlight);\n}\n";
var colors = {"white":"TpLksR41OM0-","grey":"_51WS98pPpKY-","greyBlue":"eenEpNGpzfA-","greyBlueDark":"vhEzXPEfZyQ-","greyBlueLighter":"pvDSIqHkL1g-","blue":"f80PxizYkj4-","lightBlue":"O7JR2KGCfcg-","green":"kBAjqBTXEsI-","yellow":"wNm-EF7M4g0-","red":"RQVWfFQDPu0-","navy":"xl38E3cTBRo-","orange":"Y0tpTN7mt2M-","interactive":"haFR6Zwp-a4-","interactiveHover":"uZjlqe-em2E-","destructive":"pv3CFbTk-Mg-","destructiveHover":"E5Yz9BNVLPg-","interactiveSubtle":"Ag8mttBCQtU-","interactiveSubtleHover":"XY4qV0-e3DM-","disabled":"ruwXWGEJXS4-","disabledSecondary":"OinDbMeLOso-","focus":"JwWv29JWwzE-","critical":"avM4gudjYeg-","criticalSurface":"amAXqNTFYcg-","criticalOnSurface":"omSKoausvXA-","warning":"aQIlKXSkyDM-","warningSurface":"hvzZjM9cQns-","warningOnSurface":"M1oIoiDS82s-","success":"HavlDN2ZD-k-","successSurface":"YCX5CYqdHdU-","successOnSurface":"yDtFAzbc4N0-","informative":"ItL-7gRcsBo-","informativeSurface":"_1kkDnQDmX54-","informativeOnSurface":"C1HyOUrN-2U-","inactive":"qV6UDI0M-NE-","inactiveSurface":"_3-xvTk8wOcc-","inactiveOnSurface":"ZPvBgU-Flrw-","heading":"_4QMQd-zVb70-","text":"dbTNEuj0Xmw-","textSecondary":"FNvqhTrxwHc-","textReverse":"fgWgyrLt8xI-","textReverseSecondary":"JfcuaSm1ZSk-","surface":"hQLb9vztL-Q-","surfaceHover":"epshb9WJQDU-","surfaceActive":"IcsOosya54c-","surfaceBackground":"zXzW4ql9U-I-","surfaceReverse":"dbzz7qC7vHY-","brand":"wBuQiZfdPrI-","brandHighlight":"TEOLQtdrGAU-"};
styleInject(css_248z);

/* tslint:disable */
/* eslint-disable */
/* This file is automatically generated and should not be edited. */
/* Add your icons SVG file under assets/icons and run "npm run bootstrap" */
const iconMap = {
    "icons": {
        "add": [
            "M12 3a1 1 0 0 0-1 1v7H4a1 1 0 1 0 0 2h7v7a1 1 0 1 0 2 0v-7h7a1 1 0 1 0 0-2h-7V4a1 1 0 0 0-1-1Z"
        ],
        "addNote": [
            "M8 2a2 2 0 0 0-2 2v2h2V4h8.586L20 7.414V20H8v-2H6v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.414A2 2 0 0 0 21.414 6L18 2.586A2 2 0 0 0 16.586 2H8Z",
            "M6 8a1 1 0 0 0-1 1v2H3a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2H7V9a1 1 0 0 0-1-1Z"
        ],
        "address": [
            "M12.774 21.6C14.595 19.094 19 13.068 19 10a7 7 0 1 0-14 0c0 3.067 4.405 9.093 6.226 11.6a.952.952 0 0 0 1.548 0ZM12 19.5S7 12.761 7 10a5 5 0 0 1 10 0c0 2.761-5 9.5-5 9.5Z",
            "M14 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        ],
        "alert": [
            "M12 7a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1Zm-1 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
            "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Z"
        ],
        "angieslist": [
            "M9.87 19.42 11.417 15H17a5 5 0 0 0 0-10H7a5 5 0 0 0-.252 9.994l1.549 4.425a.833.833 0 0 0 1.573 0Zm.247-5.752-1.034 2.954-1.021-2.92a.5.5 0 0 0-.448-.334l-.784-.039A3.333 3.333 0 0 1 7 6.667h10a3.333 3.333 0 0 1 0 6.666h-6.411a.5.5 0 0 0-.472.335Z"
        ],
        "apple": [
            "M18.467 12.754c-.027-2.996 2.453-4.453 2.566-4.52-1.404-2.048-3.581-2.328-4.346-2.35-1.828-.193-3.601 1.094-4.533 1.094-.95 0-2.384-1.076-3.93-1.044-1.988.03-3.849 1.182-4.87 2.97C1.25 12.55 2.82 17.91 4.838 20.856c1.01 1.443 2.189 3.055 3.733 2.998 1.51-.062 2.074-.963 3.897-.963 1.806 0 2.335.963 3.91.927 1.62-.026 2.641-1.45 3.615-2.907 1.166-1.654 1.635-3.283 1.653-3.367-.038-.013-3.147-1.2-3.178-4.79Zm-2.974-8.81c.812-1.015 1.368-2.397 1.213-3.8-1.175.053-2.646.814-3.492 1.807-.75.876-1.418 2.31-1.246 3.66 1.321.099 2.677-.666 3.525-1.666Z"
        ],
        "apps": [
            "M3 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2 0v4h4V5H5Zm8 0a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5Zm2 0v4h4V5h-4ZM5 13a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H5Zm4 2v4H5v-4h4Zm7-1a1 1 0 1 1 2 0v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2Z"
        ],
        "archive": [
            "M5 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2H5Zm1 1a2 2 0 0 0-2 2h16a2 2 0 0 0-2-2H6Zm3 7a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Z",
            "M2 11a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8Zm2 0v8h16v-8H4Z"
        ],
        "arrowDown": [
            "M7.703 8.291a.996.996 0 0 0-1.41.001.994.994 0 0 0 0 1.41l5 5.005a.998.998 0 0 0 1.415 0l5-5a.994.994 0 0 0 0-1.41.995.995 0 0 0-1.411-.001L12 12.584 7.703 8.291Z"
        ],
        "arrowLeft": [
            "M15.209 15.797a.996.996 0 0 1-.001 1.41.994.994 0 0 1-1.41 0l-5.005-5a.998.998 0 0 1 0-1.415l5-5a.994.994 0 0 1 1.41 0 .996.996 0 0 1 .001 1.411L10.916 11.5l4.293 4.297Z"
        ],
        "arrowRight": [
            "M8.791 15.797a.996.996 0 0 0 .001 1.41.994.994 0 0 0 1.41 0l5.005-5a.998.998 0 0 0 0-1.415l-5-5a.994.994 0 0 0-1.41 0 .995.995 0 0 0-.001 1.411l4.288 4.297-4.293 4.297Z"
        ],
        "arrowUp": [
            "M16.297 14.709a.996.996 0 0 0 1.41-.001.994.994 0 0 0 0-1.41l-5-5.005a.998.998 0 0 0-1.415 0l-5 5a.994.994 0 0 0 0 1.41.996.996 0 0 0 1.411.001L12 10.416l4.297 4.293Z"
        ],
        "availability": [
            "M2 5a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm0 14a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM4 8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H4Zm5 2v4H4v-4h5Zm6-2a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2h-5Zm5 2v1h-5v-1h5Z"
        ],
        "backArrow": [
            "M7.414 13 10 15.586A1 1 0 0 1 8.586 17l-4.293-4.293a1 1 0 0 1 0-1.414L8.586 7A1 1 0 1 1 10 8.414L7.414 11H19a1 1 0 0 1 0 2H7.414Z"
        ],
        "badInvoice": [
            "M13.977 9c.026 0 .65.04 1.316.707a1 1 0 0 0 1.414-1.414A4.487 4.487 0 0 0 15 7.2V7a1 1 0 0 0-2 0v.184A2.996 2.996 0 0 0 11 10c0 2.28 1.727 2.713 2.758 2.97C14.873 13.25 15 13.354 15 14c0 .552-.448 1-.976 1-.026 0-.65-.04-1.317-.707a1 1 0 1 0-1.414 1.415A4.502 4.502 0 0 0 13 16.798v.2a1 1 0 0 0 2 0v-.184A2.995 2.995 0 0 0 17 14c0-2.28-1.726-2.712-2.757-2.97C13.128 10.752 13 10.646 13 10c0-.55.45-1 .977-1Zm-9.265 3-1.445-1.445a.911.911 0 0 1 1.288-1.288L6 10.712l1.445-1.445a.911.911 0 1 1 1.288 1.288L7.288 12l1.445 1.445a.911.911 0 0 1-1.288 1.288L6 13.288l-1.445 1.445a.911.911 0 0 1-1.288-1.288L4.712 12Z",
            "M8 2a2 2 0 0 0-2 2v2h2V4h8.586L20 7.414V20H8v-2H6v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.414A2 2 0 0 0 21.414 6L18 2.586A2 2 0 0 0 16.586 2H8Z",
            "M6 6h2v1H6V6Zm2 11H6v1h2v-1Z"
        ],
        "batch": [
            "M9 6a2 2 0 0 1 2-2h4.586A2 2 0 0 1 17 4.586L20.414 8A2 2 0 0 1 21 9.414V18a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V6Zm2 0v12h8V9.414L15.586 6H11ZM6 7a2 2 0 0 1 2-2v14a2 2 0 0 1-2-2V7ZM5 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2V6Z"
        ],
        "calendar": [
            "M15 4a1 1 0 1 1 2 0v1h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2V4a1 1 0 0 1 2 0v1h6V4ZM5 7v2h14V7H5Zm14 4H5v8h14v-8Z"
        ],
        "camera": [
            "M8.618 4a2 2 0 0 0-1.789 1.106L6.382 6H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-2.382l-.447-.894A2 2 0 0 0 15.382 4H8.618Zm-1 4 1-2h6.764l1 2H20v10H4V8h3.618ZM16 13a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-2 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z"
        ],
        "chat": [
            "M3 2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2v2a1 1 0 0 0 1.65.76L9.87 10H15a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3Zm1 6V4h10v4H9.13L7 9.826V8H4Z",
            "M21 12a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-2v2a1 1 0 0 1-1.65.76L14.13 20H9a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h12Zm-1 6v-4H10v4h4.87L17 19.826V18h3Z"
        ],
        "checkbox": [
            "M8.72 11.211a1 1 0 1 0-1.415 1.414l2.68 3.086a1 1 0 0 0 1.414 0l5.274-4.992a1 1 0 1 0-1.414-1.414l-4.567 4.285-1.973-2.379Z",
            "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm14 2v14H5V5h14Z"
        ],
        "checkmark": [
            "M4.703 12.029a1 1 0 1 0-1.414 1.414l4.699 5.293a1 1 0 0 0 1.414 0L20.695 7.443a1 1 0 1 0-1.414-1.414L8.695 16.615l-3.992-4.586Z"
        ],
        "chemical": [
            "M8 4a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2v3.783l4.91 10.803A1 1 0 0 1 19 21H5a1 1 0 0 1-.91-1.414L9 8.783V5a1 1 0 0 1-1-1Zm3 5.217L9.735 12H11a1 1 0 1 1 0 2H9a1.01 1.01 0 0 1-.168-.014L8.372 15H12a1 1 0 1 1 0 2H7.462l-.909 2h10.894L13 9.217V5h-2v4.217Z"
        ],
        "clearFilters": [
            "M4.705 4.291a.998.998 0 0 0-1.414 0 .996.996 0 0 0 0 1.414L8.5 11.418V21a1 1 0 0 0 1.6.8l4-3a1 1 0 0 0 .4-.8v-.582l3.793 3.29a.996.996 0 0 0 .679.293.997.997 0 0 0 1.019-1.138.996.996 0 0 0-.284-.569L14.5 14.59v-.008l-2-2v.008l-2.24-2.24-.047-.054L4.705 4.29Zm5.795 9.127 2 2V17.5l-2 1.5v-5.582ZM7.95 5 6 3.05V3h14a1 1 0 0 1 .76 1.65L15 11.37v.68l-1.732-1.732L17.826 5H7.95Z"
        ],
        "clients": [
            "M13 14a3.008 3.008 0 0 0-3 2.735c-.01.145.11.265.256.265h5.492c.145 0 .266-.12.25-.265A3.008 3.008 0 0 0 13 14Zm0-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
            "M4 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2H3a1 1 0 1 1 0-2h1v-3H3a1 1 0 1 1 0-2h1V8H3a1 1 0 0 1 0-2h1V5Zm2 0v15h14V5H6Z"
        ],
        "clockIn": [
            "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm0-2a8 8 0 1 1 0-16 8 8 0 0 1 0 16Z",
            "M9 9a1 1 0 0 1 1.514-.857l5 3a1 1 0 0 1 0 1.714l-5 3A1 1 0 0 1 9 15V9Z"
        ],
        "clockOut": [
            "M9 10a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4Z",
            "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Z"
        ],
        "cog": [
            "M13.207 4.017v1.939l1.248.51c.51.209.99.489 1.439.828l1.059.83 1.169-.67.51-.3.998 1.729-.51.3-1.168.669.18 1.329c.05.33.07.589.07.829s-.02.5-.07.829l-.18 1.329 1.169.669.51.3-1 1.728-.51-.3-1.168-.67-1.059.83c-.44.35-.93.63-1.439.83l-1.248.509v1.938l-2.433-.02v-1.938l-1.249-.51a6.44 6.44 0 0 1-1.438-.828l-1.06-.82-1.168.67-.51.3-.999-1.729.51-.3 1.169-.669-.18-1.329c-.05-.34-.07-.599-.07-.839s.02-.5.07-.829l.18-1.329-1.16-.679-.509-.3 1-1.728.509.3 1.159.67 1.059-.83c.45-.34.929-.62 1.438-.83l1.25-.509V3.998l2.432.02Zm-1.212 11.97c2.208 0 4.209-1.77 4.209-3.977 0-2.208-2.001-4.016-4.21-4.016-2.207 0-4.217 1.788-4.217 3.996s2.02 3.996 4.218 3.996Zm2.21-13.968L9.786 2c-.55 0-.999.45-.999.999v1.578c-.7.29-1.339.66-1.918 1.12l-1.379-.8a1.01 1.01 0 0 0-1.368.37l-2 3.456a1.011 1.011 0 0 0 .37 1.37l1.379.798c-.05.36-.09.72-.09 1.1 0 .379.03.739.09 1.108l-1.379.8a1.005 1.005 0 0 0-.492.74.984.984 0 0 0 .122.618l1.999 3.467c.18.32.519.5.859.5.17 0 .34-.04.5-.13l1.378-.8c.58.45 1.219.83 1.918 1.11v1.578c0 .55.45.999 1 .999l4.42.019c.55 0 .999-.45.999-.999v-1.579a8.18 8.18 0 0 0 1.918-1.108l1.378.799c.16.09.33.13.5.13.35 0 .68-.18.87-.5l1.997-3.456a.985.985 0 0 0 .095-.78 1.022 1.022 0 0 0-.464-.59l-1.38-.798c.05-.36.09-.73.09-1.11 0-.379-.03-.739-.09-1.108l1.38-.8c.282-.164.453-.443.492-.74a.984.984 0 0 0-.123-.618L19.86 5.276a.99.99 0 0 0-.859-.5c-.17 0-.34.04-.5.13l-1.378.8a7.942 7.942 0 0 0-1.918-1.11V3.019c0-.55-.45-.999-1-.999Zm-2.21 11.97c-1.1 0-2.22-.9-2.22-1.999 0-1.099 1.12-1.998 2.22-1.998 1.099 0 2.21.919 2.21 2.018 0 1.099-1.101 1.978-2.21 1.978Z"
        ],
        "company": [
            "M6 6h2v2H6V6Zm6 0h-2v2h2V6Zm-2 3h2v2h-2V9ZM8 9H6v2h2V9Zm2 3h2v2h-2v-2Zm-2 0H6v2h2v-2Z",
            "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10V5a2 2 0 0 0-2-2H5Zm8 2v14h-3v-2a1 1 0 1 0-2 0v2H5V5h8Zm3 0h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3v-2h3V7h-3V5Z",
            "M16 9h2v2h-2V9Zm2 3h-2v2h2v-2Z"
        ],
        "compose": [
            "M9.586 10.417A2 2 0 0 0 9 11.83v3.171h3.172a2 2 0 0 0 1.414-.585l7.83-7.831c.416-.416.61-.968.584-1.512a1.993 1.993 0 0 0-.583-1.317l-1.172-1.171a1.993 1.993 0 0 0-1.317-.584 1.995 1.995 0 0 0-1.511.584l-7.831 7.83ZM11 13.002v-1.171L18.83 4l1.172 1.172-7.83 7.83H11Z",
            "M5 3h8v2H5v14h14v-8h2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"
        ],
        "copy": [
            "M8 4a2 2 0 0 1 2-2h5a2 2 0 0 1 1.414.586l4 4A2 2 0 0 1 21 8v8a2 2 0 0 1-2 2V8l-4-4H8ZM6 6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-9.5a2 2 0 0 0-.586-1.414l-2.5-2.5A2 2 0 0 0 12.5 6H6Zm0 14V8h6.5l2.5 2.5V20H6Z"
        ],
        "cross": [
            "M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414L12 10.586Z"
        ],
        "customize": [
            "M14.707 3.88A2.987 2.987 0 0 1 16.83 3a2.99 2.99 0 0 1 2.121.88l1.172 1.175c.585.587.878 1.357.878 2.126 0 .77-.293 1.54-.878 2.127l-9.22 9.291a1 1 0 0 1-.313.213l-4.795 2.02a2.017 2.017 0 0 1-.788.168 1.988 1.988 0 0 1-1.414-.593A2 2 0 0 1 3 19.037a2.021 2.021 0 0 1 .168-.837l2.108-4.714c.05-.117.122-.223.212-.314l9.22-9.291Zm2.829 1.418a.998.998 0 0 0-1.414 0l-.879.881 2.586 2.592.878-.88a1.004 1.004 0 0 0 0-1.418l-1.171-1.175Zm-1.121 4.89-2.586-2.591-6.22 6.284 2.586 2.592 6.22-6.285Zm-7.972 7.364-1.911-1.915-1.526 3.352 3.437-1.437Z",
            "M8.26 2.611a2.086 2.086 0 0 0-2.951 0L2.61 5.31a2.086 2.086 0 0 0 0 2.95l3.89 3.89L8 10.697 6.694 9.392l.612-.611A1.043 1.043 0 1 0 5.83 7.306l-.61.61-1.134-1.132 2.698-2.698L10.637 8 12 6.637 8.26 2.611Zm9.24 9.123-1.5 1.45 3.914 4.032-2.698 2.698-1.133-1.133.611-.611a1.043 1.043 0 0 0-1.475-1.476l-.611.611L13 15.5 11.5 17l4.24 4.389a2.086 2.086 0 0 0 2.951 0l2.698-2.698a2.086 2.086 0 0 0 0-2.95L17.5 11.734Z"
        ],
        "dashboard": [
            "M19.99 4H4.02C2.9 4 2 4.9 2 6.02v11.97c0 1.11.9 2.02 2.02 2.02h15.97c1.11 0 2.02-.9 2.02-2.02V6.02A2.027 2.027 0 0 0 19.99 4ZM8 18H4V6h4v12Zm12 0H10v-8h10v8Zm0-10H10V6h10v2Z"
        ],
        "directions": [
            "M2.293 12.707a1 1 0 0 1 0-1.414l9-9a1 1 0 0 1 1.414 0l2.5 2.5-1.414 1.414L12 4.414 4.414 12 12 19.586l3.793-3.793 1.414 1.414-4.5 4.5a1 1 0 0 1-1.414 0l-9-9Z",
            "M17.293 6.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L18.586 11H13a1 1 0 0 0-1 1v2.5a1 1 0 1 1-2 0V12a3 3 0 0 1 3-3h5.586l-1.293-1.293a1 1 0 0 1 0-1.414Z"
        ],
        "download": [
            "M2 10.5C2 13.538 4.686 16 8 16v-2c-2.21 0-4-1.567-4-3.5S5.79 7 8 7a4.5 4.5 0 0 1 1.414.225A4 4 0 0 1 17 9h.5a2.5 2.5 0 0 1 0 5H16v2h1.5a4.5 4.5 0 0 0 1.215-8.834A6.003 6.003 0 0 0 8.51 5.02 6.633 6.633 0 0 0 8 5c-3.314 0-6 2.462-6 5.5Z",
            "M11 12v5.586L10.414 17A1 1 0 0 0 9 18.414l2.293 2.293a1 1 0 0 0 1.414 0L15 18.414A1 1 0 0 0 13.586 17l-.586.586V12a1 1 0 1 0-2 0Z"
        ],
        "drag": [
            "M8 4 7 5v2l1 1h2l1-1V5l-1-1H8Zm0 6-1 1v2l1 1h2l1-1v-2l-1-1H8Zm0 6-1 1v2l1 1h2l1-1v-2l-1-1H8Zm6-12-1 1v2l1 1h2l1-1V5l-1-1h-2Zm0 6-1 1v2l1 1h2l1-1v-2l-1-1h-2Zm0 6-1 1v2l1 1h2l1-1v-2l-1-1h-2Z"
        ],
        "dropdown": [
            "m12 12.586-2.293-2.294a.997.997 0 0 0-1.414 0 .997.997 0 0 0 0 1.414l3 3.001a.997.997 0 0 0 1.414 0l3.005-3a.996.996 0 0 0 0-1.414.997.997 0 0 0-1.414 0L12 12.586Z",
            "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Z"
        ],
        "edit": [
            "M14.707 3.923a2.987 2.987 0 0 1 2.121-.88c.768 0 1.536.293 2.122.88l1.171 1.174c.586.588.879 1.357.879 2.127 0 .77-.293 1.539-.879 2.126l-9.22 9.292a1 1 0 0 1-.313.212l-4.794 2.02a2.017 2.017 0 0 1-.788.168 1.988 1.988 0 0 1-1.415-.593A2 2 0 0 1 3 19.08a2.021 2.021 0 0 1 .167-.837l2.108-4.713a.99.99 0 0 1 .212-.314l9.22-9.292Zm2.828 1.418a.998.998 0 0 0-1.414 0l-.878.88 2.585 2.592.88-.88c.39-.392.39-1.027 0-1.418L17.535 5.34Zm-1.12 4.89-2.587-2.592-6.22 6.285 2.586 2.591 6.22-6.284Zm-7.972 7.364-1.911-1.916-1.526 3.353 3.437-1.437Z"
        ],
        "email": [
            "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7Zm16.667 0H5.333L12 14l6.667-7ZM4 8.517V19h16V8.517l-6.545 6.94a2 2 0 0 1-2.91 0L4 8.517Z"
        ],
        "embed": [
            "M6 4a2 2 0 0 0-2 2v2h2V6h12v2h2V6a2 2 0 0 0-2-2H6ZM4 18v-2h2v2h12v-2h2v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z",
            "M10.184 15.579a.996.996 0 0 0 1.235.33.997.997 0 0 0 .53-.592l2-6.001a1 1 0 1 0-1.897-.632l-2 6a.998.998 0 0 0 .132.895ZM7.446 9.168a.995.995 0 0 1 .887-.111.996.996 0 0 1 .667.98.999.999 0 0 1-.445.795L6.803 12l1.752 1.168a.999.999 0 0 1-.325 1.806.997.997 0 0 1-.784-.141l-3-2.001a1 1 0 0 1 0-1.664l3-2ZM16 15c.191 0 .384-.054.555-.167l3-2a1 1 0 0 0 0-1.664l-3-2.001a.997.997 0 0 0-1.387.277.999.999 0 0 0 .277 1.387l1.753 1.169-1.753 1.168A.999.999 0 0 0 16.001 15Z"
        ],
        "engine": [
            "M7.007 5.935a1.001 1.001 0 0 0 0 2.002h3.003v1.001H7.007a2.002 2.002 0 0 0-2.002 2.002v1.001H4.004V9.94a1.001 1.001 0 0 0-2.002 0v6.006a1.001 1.001 0 0 0 2.002 0v-2.002h1v1.001c0 1.106.897 2.002 2.003 2.002h1v1.001c0 .553.449 1.001 1.002 1.001h10.01v-3.003h1v3.003h1.002a1 1 0 0 0 1-1V11.94a1 1 0 0 0-1-1H20.02v3.002h-1.001V10.94a2.002 2.002 0 0 0-2.002-2.002h-5.005v-1h3.003a1.001 1.001 0 1 0 0-2.003H7.007Zm0 9.01V10.94h10.01v6.006H10.01v-2.002H7.007Z"
        ],
        "event": [
            "M14 13a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2Z",
            "M16 3a1 1 0 0 0-1 1v1H9V4a1 1 0 0 0-2 0v1H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2V4a1 1 0 0 0-1-1Zm3 4v2H5V7h14ZM5 11h14v8H5v-8Z"
        ],
        "excel": [
            "M11 11v-1h2a1 1 0 1 0 0-2h-3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3a1 1 0 1 0 0-2h-2v-1h2a1 1 0 1 0 0-2h-2Z",
            "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.414A2 2 0 0 0 19.414 6L16 2.586A2 2 0 0 0 14.586 2H6Zm0 18V4h8.586L18 7.414V20H6Z"
        ],
        "expense": [
            "M13.293 8.707C12.626 8.04 12.003 8 11.977 8 11.45 8 11 8.45 11 9c0 .646.128.752 1.243 1.03C13.274 10.288 15 10.72 15 13a2.995 2.995 0 0 1-2 2.814v.184a1 1 0 0 1-2 0v-.2a4.502 4.502 0 0 1-1.707-1.09 1 1 0 1 1 1.414-1.415c.667.667 1.291.707 1.317.707.528 0 .976-.448.976-1 0-.646-.127-.75-1.242-1.03C10.728 11.713 9 11.28 9 9a2.996 2.996 0 0 1 2-2.816V6a1 1 0 0 1 2 0v.2a4.49 4.49 0 0 1 1.707 1.093 1 1 0 0 1-1.414 1.414Z",
            "M4 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v17a1 1 0 0 1-1.555.832l-2.318-1.545-1.42 1.42a1 1 0 0 1-1.414 0L12 20.414l-1.293 1.293a1 1 0 0 1-1.414 0l-1.42-1.42-2.318 1.545A1 1 0 0 1 4 21V4Zm2 0v15.131l1.445-.963a1 1 0 0 1 1.262.125L10 19.586l1.293-1.293a1 1 0 0 1 1.414 0L14 19.586l1.293-1.293a1 1 0 0 1 1.262-.125L18 19.13V4H6Z"
        ],
        "export": [
            "M13 5a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V7.414L8.707 16.71a.996.996 0 0 1-1.414 0 .997.997 0 0 1 0-1.414L16.586 6H14a1 1 0 0 1-1-1Z",
            "M3 5a2 2 0 0 1 2-2h6v2H5v14h14v-6h2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Z"
        ],
        "eye": [
            "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-2 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z",
            "M21.863 12.477C20.794 14.2 16.703 20 12 20c-4.702 0-8.795-5.8-9.863-7.523a.903.903 0 0 1 0-.954C3.205 9.8 7.297 4 12 4c4.703 0 8.794 5.8 9.863 7.523a.903.903 0 0 1 0 .954ZM20 12s-3.582-6-8-6-8 6-8 6 3.582 6 8 6 8-6 8-6Z"
        ],
        "eyeCrossed": [
            "M6.695 6.285 4.703 4.29A.996.996 0 0 0 4 3.996a.997.997 0 0 0-1 1.086c.02.226.116.448.29.621l1.953 1.958c-1.433 1.514-2.63 3.093-3.106 3.862a.903.903 0 0 0 0 .954C3.205 14.2 7.297 20 12 20c1.484 0 2.893-.578 4.16-1.422l2.15 2.13A.996.996 0 0 0 19 21a.997.997 0 0 0 1-1.184.996.996 0 0 0-.276-.523l-1.98-1.96L6.694 6.285ZM12 18c-4.418 0-8-6-8-6s.944-1.582 2.46-3.12l1.773 1.771a4 4 0 0 0 5.116 5.115l1.464 1.465C13.938 17.7 12.99 18 12 18Zm-1.943-5.525a2.003 2.003 0 0 0 1.468 1.468l-1.468-1.468Zm1.242-4.414 4.64 4.64a4 4 0 0 0-4.64-4.64Z",
            "M17.939 14.7A18.455 18.455 0 0 0 20 12s-3.582-6-8-6c-.785 0-1.544.19-2.261.501L8.344 5.106C9.476 4.436 10.71 4 12 4c4.703 0 8.794 5.8 9.863 7.523a.903.903 0 0 1 0 .954c-.432.697-1.481 2.059-2.713 3.435l-1.211-1.211Z"
        ],
        "facebook": [
            "M14.188 6.375H17V3h-2.812a3.942 3.942 0 0 0-3.938 3.938v1.688H8v3.375h2.25v9h3.375v-9h2.812L17 8.626h-3.375V6.938a.57.57 0 0 1 .563-.563Z"
        ],
        "file": [
            "M14 9a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0v-1.5h2a1 1 0 1 0 0-2h-2V10h2a1 1 0 0 0 1-1Z",
            "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.414A2 2 0 0 0 19.414 6L16 2.586A2 2 0 0 0 14.586 2H6Zm0 18V4h8.586L18 7.414V20H6Z"
        ],
        "filter": [
            "M16 9a3.001 3.001 0 0 0 2.83-2H20a1 1 0 1 0 0-2h-1.17a3.001 3.001 0 0 0-5.66 0H4a1 1 0 0 0 0 2h9.17A3.001 3.001 0 0 0 16 9Zm1-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-8.17 7a3.001 3.001 0 1 1 0-2H20a1 1 0 1 1 0 2H8.83ZM7 12a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm1.17 7a3.001 3.001 0 0 0 5.66 0H20a1 1 0 1 0 0-2h-6.17a3.001 3.001 0 0 0-5.66 0H4a1 1 0 1 0 0 2h4.17ZM11 19a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
        ],
        "fuel": [
            "M7 7h6v5H7V7Z",
            "M4 6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10h4v-5h-2v-1h-.5a.5.5 0 0 1 0-1H20a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-4v2h1a1 1 0 0 1 1 1v1H2v-1a1 1 0 0 1 1-1h1V6Zm10 0H6v14h8V6Z"
        ],
        "future": [
            "M12.406 3.22a1.005 1.005 0 0 1 1.41.155l3.512 4.376c.586.73.586 1.768 0 2.498l-3.512 4.376a1.005 1.005 0 0 1-1.41.156.998.998 0 0 1-.157-1.406L14.96 10H9.52a4.507 4.507 0 0 0-4.514 4.5c0 2.485 2.02 4.5 4.514 4.5h3.476c.554 0 1.003.448 1.003 1s-.45 1-1.003 1H9.52C5.92 21 3 18.09 3 14.5S5.92 8 9.521 8h5.437L12.25 4.625a.998.998 0 0 1 .157-1.406Zm4.232 0a1.006 1.006 0 0 1 1.41.155l3.512 4.376c.587.73.587 1.768 0 2.498l-3.511 4.376a1.006 1.006 0 0 1-1.41.156.998.998 0 0 1-.157-1.406L19.994 9l-3.512-4.375a.998.998 0 0 1 .157-1.406Z"
        ],
        "gift": [
            "M6 5.5a3.5 3.5 0 0 1 6.363-2.014A3 3 0 0 1 16.83 7H21a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3.337A3.486 3.486 0 0 1 6 5.5ZM13 20h5v-7h-5v7Zm-2-7H6v7h5v-7Zm2-2h7V9h-7v2Zm-2-2H4v2h7V9Zm0-2V5.5A1.5 1.5 0 1 0 9.5 7H11Zm2-1v1h1a1 1 0 1 0-1-1Z"
        ],
        "google": [
            "M12.648 10.488v2.623h4.336c-.174 1.126-1.31 3.298-4.336 3.298-2.608 0-4.738-2.163-4.738-4.828 0-2.665 2.13-4.828 4.738-4.828 1.488 0 2.478.634 3.045 1.178l2.074-1.998c-1.332-1.244-3.059-2-5.119-2a7.643 7.643 0 0 0-7.643 7.65 7.635 7.635 0 0 0 7.643 7.643c4.41 0 7.338-3.101 7.338-7.47 0-.503-.056-.888-.122-1.268h-7.216Z"
        ],
        "googlePlay": [
            "M20.561 11.159 4.505 2.19c-.339-.189-.651-.232-.904-.154H3.6c-.364.115-.6.49-.6 1.057l.002 17.812c0 .56.229.928.58 1.051.256.088.575.046.922-.145L20.56 12.84c.828-.466.828-1.22 0-1.682h.001Z"
        ],
        "grid": [
            "M4 2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm8 2v2H4V4h8Zm0 5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-8Zm8 4h-8v-2h8v2ZM5 18a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-2Zm2 0v2h8v-2H7ZM4 9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2H4Zm2 2v2H4v-2h2Zm10-7a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V4Zm2 0v2h2V4h-2Z"
        ],
        "happyFace": [
            "M8.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM17 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-7.072 4.129a1 1 0 1 0-1.856.742c.688 1.72 2.376 2.504 3.928 2.504s3.24-.784 3.928-2.504a1 1 0 0 0-1.857-.742c-.312.78-1.123 1.246-2.071 1.246-.948 0-1.76-.466-2.072-1.246Z",
            "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Z"
        ],
        "help": [
            "M11.969 7c-1.375 0-2.575 1.161-2.707 1.293a1.001 1.001 0 0 0 1.41 1.417c.291-.286.904-.71 1.296-.71a1 1 0 0 1 .591 1.808c-1.01.74-1.59 1.808-1.59 2.929V14a1 1 0 0 0 2 0v-.263c0-.653.484-1.105.773-1.317A3.013 3.013 0 0 0 14.968 10c0-1.654-1.345-3-3-3ZM12 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
            "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Z"
        ],
        "home": [
            "M13.147 3.582a2 2 0 0 0-2.294 0l-9.426 6.599a1 1 0 1 0 1.147 1.638L5 10.121V18a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-7.88l2.427 1.7a1 1 0 0 0 1.146-1.64l-9.426-6.598ZM17 8.721V18a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V8.72l5-3.5 5 3.5Z"
        ],
        "image": [
            "M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm7.5 5.819-2.616-3.14a.5.5 0 0 0-.768 0L11 15.52l-1.116-1.34a.5.5 0 0 0-.768 0L5.933 18H18v-3.681Z",
            "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2 0v14h14V5H5Z"
        ],
        "import": [
            "M19.71 4.292a.998.998 0 0 1 0 1.414L10.414 15H13a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1v-5a1 1 0 1 1 2 0v2.586l9.295-9.294A.995.995 0 0 1 18.961 4a.997.997 0 0 1 .749.292Z",
            "M3 5a2 2 0 0 1 2-2h9v2H5v14h14v-9h2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Z"
        ],
        "instagram": [
            "M12 2c-2.716 0-3.056.012-4.123.06-1.064.049-1.791.218-2.427.465a4.901 4.901 0 0 0-1.772 1.153A4.901 4.901 0 0 0 2.525 5.45c-.247.636-.416 1.363-.465 2.427C2.012 8.944 2 9.284 2 12s.012 3.056.06 4.123c.049 1.064.218 1.791.465 2.427a4.902 4.902 0 0 0 1.153 1.772 4.902 4.902 0 0 0 1.772 1.153c.636.247 1.363.416 2.427.465 1.067.048 1.407.06 4.123.06s3.056-.012 4.123-.06c1.064-.049 1.791-.218 2.427-.465a4.902 4.902 0 0 0 1.772-1.153 4.902 4.902 0 0 0 1.153-1.772c.247-.636.416-1.363.465-2.427.048-1.067.06-1.407.06-4.123s-.012-3.056-.06-4.123c-.049-1.064-.218-1.791-.465-2.427a4.902 4.902 0 0 0-1.153-1.772 4.902 4.902 0 0 0-1.772-1.153c-.636-.247-1.363-.416-2.427-.465C15.056 2.012 14.716 2 12 2Zm0 1.802c2.67 0 2.986.01 4.04.058.976.045 1.505.207 1.858.344.466.182.8.399 1.15.748.35.35.566.684.748 1.15.137.353.3.882.344 1.857.048 1.055.058 1.37.058 4.041 0 2.67-.01 2.986-.058 4.04-.045.976-.207 1.505-.344 1.858-.182.466-.398.8-.748 1.15-.35.35-.683.566-1.15.748-.353.137-.882.3-1.857.344-1.054.048-1.37.058-4.041.058-2.67 0-2.987-.01-4.04-.058-.976-.045-1.505-.207-1.858-.344a3.097 3.097 0 0 1-1.15-.748 3.098 3.098 0 0 1-.748-1.15c-.137-.353-.3-.882-.344-1.857-.048-1.055-.058-1.37-.058-4.041 0-2.67.01-2.986.058-4.04.045-.976.207-1.505.344-1.858.182-.466.399-.8.748-1.15.35-.35.684-.566 1.15-.748.353-.137.882-.3 1.857-.344 1.055-.048 1.37-.058 4.041-.058ZM6.865 12a5.135 5.135 0 1 1 10.27 0 5.135 5.135 0 0 1-10.27 0ZM12 15.333a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666Zm5.338-7.471a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z"
        ],
        "invoice": [
            "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.414A2 2 0 0 0 19.414 6L16 2.586A2 2 0 0 0 14.586 2H6Zm0 18V4h8.586L18 7.414V20H6Zm7.293-10.293C12.626 9.04 12.003 9 11.977 9 11.45 9 11 9.45 11 10c0 .646.128.752 1.243 1.03C13.274 11.288 15 11.72 15 14a2.995 2.995 0 0 1-2 2.814v.184a1 1 0 0 1-2 0v-.2a4.502 4.502 0 0 1-1.707-1.09 1 1 0 1 1 1.414-1.415c.667.667 1.291.707 1.317.707.528 0 .976-.448.976-1 0-.646-.127-.75-1.242-1.03C10.728 12.713 9 12.28 9 10a2.996 2.996 0 0 1 2-2.816V7a1 1 0 0 1 2 0v.2a4.49 4.49 0 0 1 1.707 1.093 1 1 0 0 1-1.414 1.414Z"
        ],
        "invoiceLater": [
            "M6 4a2 2 0 0 1 2-2h8.586A2 2 0 0 1 18 2.586L21.414 6A2 2 0 0 1 22 7.414V20a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-2h2v2h12V7.414L16.586 4H8v2H6V4Z",
            "M15.293 9.707C14.626 9.04 14.003 9 13.977 9 13.45 9 13 9.45 13 10c0 .646.128.752 1.243 1.03C15.274 11.288 17 11.72 17 14a2.995 2.995 0 0 1-2 2.814v.184a1 1 0 0 1-2 0v-.2a4.502 4.502 0 0 1-1.707-1.09 1 1 0 0 1 1.414-1.415c.667.667 1.291.707 1.317.707.528 0 .976-.448.976-1 0-.646-.127-.75-1.242-1.03C12.728 12.713 11 12.28 11 10a2.996 2.996 0 0 1 2-2.816V7a1 1 0 0 1 2 0v.2a4.49 4.49 0 0 1 1.707 1.093 1 1 0 0 1-1.414 1.414ZM3 10a1 1 0 0 1 2 0v4a1 1 0 1 1-2 0v-4Zm4-1a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1Z"
        ],
        "job": [
            "M8.899 5.757A5.99 5.99 0 0 1 13.227 4a5.98 5.98 0 0 1 4.157 1.757L22 10.373l-4.243 4.242-3.479-3.479-1.171 1.172 1.414 1.414-6.693 6.692c-.39.39-.902.586-1.414.586A1.994 1.994 0 0 1 5 20.414L3.586 19A1.994 1.994 0 0 1 3 17.586c0-.512.195-1.024.586-1.414l6.692-6.693 1.414 1.414 1.172-1.171-3.965-3.965Zm8.858 6.03 1.415-1.414L15.97 7.17a3.999 3.999 0 0 0-3.864-1.036l5.651 5.652Zm-6.065 1.935-1.414-1.414L5 17.586 6.414 19l5.278-5.278Z"
        ],
        "jobForms": [
            "M8 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm3-3a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z",
            "M10 2a1 1 0 0 0-.707.293L7.586 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.586l-1.707-1.707A1 1 0 0 0 14 2h-4Zm6.414 4H18v14H6V6h1.586l1.707 1.707A1 1 0 0 0 10 8h4a1 1 0 0 0 .707-.293L16.414 6Zm-7-1 1-1h3.172l1 1-1 1h-3.172l-1-1Z"
        ],
        "jobOnHold": [
            "M8.899 5.757A5.99 5.99 0 0 1 13.227 4a5.98 5.98 0 0 1 4.157 1.757L22 10.373l-4.243 4.242-3.479-3.479-1.35 1.35 1.417 1.412-6.517 6.516c-.39.39-.902.586-1.414.586A1.994 1.994 0 0 1 5 20.414L3.586 19A1.994 1.994 0 0 1 3 17.586c0-.512.195-1.024.586-1.414l6.511-6.512 1.403 1.403 1.364-1.341-3.965-3.965Zm8.858 6.03 1.415-1.414L15.97 7.17a3.998 3.998 0 0 0-3.864-1.036l5.651 5.652Zm-6.065 1.935-1.414-1.414L5 17.586 6.414 19l5.278-5.278Z",
            "M3.293 4.293a.997.997 0 0 1 1.414 0L19.72 19.255a.947.947 0 0 1 .28.565c.038.325-.094.663-.345.914a.905.905 0 0 1-1.284 0L3.293 5.707A.996.996 0 0 1 3 5.008a.997.997 0 0 1 .293-.715Z"
        ],
        "knot": [
            "M15 16.35c0-.713.399-1.354.937-1.822a6 6 0 1 0-7.874 0C8.6 14.996 9 15.637 9 16.35c0 .358.29.649.65.649h4.7a.65.65 0 0 0 .65-.65Zm-1-2.308c0 .529-.43.958-.958.958h-2.084a.958.958 0 0 1-.958-.958c0-.357-.197-.68-.477-.9a4 4 0 1 1 4.954 0c-.28.22-.477.543-.477.9ZM10 18a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z"
        ],
        "link": [
            "M4.469 12.415a4.996 4.996 0 0 0-1.466 3.578 4.995 4.995 0 0 0 1.466 3.506 4.987 4.987 0 0 0 3.503 1.467 4.988 4.988 0 0 0 3.575-1.467l2.175-1.833a1 1 0 0 0 0-1.417.997.997 0 0 0-1.416 0l-2.175 1.833a3.001 3.001 0 0 1-4.247 0 3.007 3.007 0 0 1 0-4.25l1.832-2.178a1 1 0 0 0 0-1.416.998.998 0 0 0-1.416 0l-1.83 2.177Zm13.246 1.125a.997.997 0 0 1-1.415 0 1.001 1.001 0 0 1 0-1.417l1.84-2.04a3.008 3.008 0 0 0 0-4.25 3.001 3.001 0 0 0-4.248 0L11.72 7.665a.998.998 0 0 1-1.416 0 .999.999 0 0 1 0-1.417l2.174-1.832a4.987 4.987 0 0 1 3.574-1.467 4.987 4.987 0 0 1 3.504 1.467 4.996 4.996 0 0 1 1.465 3.506 4.996 4.996 0 0 1-1.465 3.578l-1.84 2.04Zm-8.42-.288a1.001 1.001 0 1 0 1.416 1.417l4.015-4.02a1 1 0 0 0-1.416-1.416l-4.015 4.019Z"
        ],
        "linkedIn": [
            "M4.928 7.924c1.066 0 1.929-.879 1.929-1.962C6.857 4.878 5.994 4 4.928 4s-1.929.879-1.929 1.962c0 1.084.863 1.962 1.929 1.962ZM3 9.231h3.857V21H3V9.231Zm6.429 0h3.558v1.855h.051c.495-.903 1.707-1.855 3.512-1.855 3.756 0 4.45 2.378 4.45 5.471v6.299h-3.709v-5.584c0-1.332-.027-3.045-1.929-3.045-1.932 0-2.226 1.45-2.226 2.948v5.681H9.429V9.231Z"
        ],
        "list": [
            "M19.296 10.557H4.798a1.209 1.209 0 0 0 0 2.416h14.498a1.208 1.208 0 1 0 0-2.416ZM4.798 8.14h14.498a1.208 1.208 0 1 0 0-2.416H4.798a1.209 1.209 0 0 0 0 2.416Zm14.498 7.25H4.798a1.208 1.208 0 1 0 0 2.416h14.498a1.207 1.207 0 1 0 0-2.416Z"
        ],
        "loadingCheck": [
            "M14.319 20.694c.142.534-.174 1.089-.72 1.177a9.999 9.999 0 0 1-9.077-16.51 10 10 0 0 1 13.04-1.671c.46.307.516.943.165 1.37-.352.425-.98.481-1.447.186a7.996 7.996 0 1 0-3.199 14.677c.547-.075 1.096.238 1.238.771Zm4.906-3.214a1 1 0 0 1 .032 1.414 9.598 9.598 0 0 1-1.94 1.578 1 1 0 1 1-1.062-1.695 7.606 7.606 0 0 0 1.556-1.264 1 1 0 0 1 1.414-.033Zm1.832-4.685a1 1 0 0 1 .76 1.193c-.15.673-.313 1.168-.467 1.586a1 1 0 1 1-1.877-.69c.132-.359.266-.765.391-1.33a1 1 0 0 1 1.193-.759Zm-.622-4.392a1 1 0 0 1 1.217.72c.046.18.137.589.192.961a1 1 0 1 1-1.979.29 8.788 8.788 0 0 0-.15-.754 1 1 0 0 1 .72-1.217Z",
            "M17.733 8.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414l2.293 2.293 5.293-5.293a1 1 0 0 1 1.415 0Z"
        ],
        "lock-1": [
            "M12.012 13.943a1 1 0 0 0-1.001 1.001v1.001a1.001 1.001 0 0 0 2.002 0v-1a1 1 0 0 0-1.001-1.002Zm0-11.01a4.004 4.004 0 0 1 4.004 4.003V9.94h2.002c1.105 0 2.002.897 2.002 2.002v7.007a2.002 2.002 0 0 1-2.002 2.002H6.006a2.002 2.002 0 0 1-2.002-2.002v-7.007c0-1.105.896-2.002 2.002-2.002h2.002V6.936a4.004 4.004 0 0 1 4.004-4.003Zm2.002 4.003a2.002 2.002 0 0 0-4.004 0V9.94h4.004V6.936Zm-8.008 5.005v7.007h12.012v-7.007H6.006Z"
        ],
        "lock": [
            "M12 14a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1-1Z",
            "M12 3a4 4 0 0 0-4 4v3H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-2V7a4 4 0 0 0-4-4Zm2 4v3h-4V7a2 2 0 1 1 4 0Zm-8 5h12v7H6v-7Z"
        ],
        "logout": [
            "M3 5a2 2 0 0 1 2-2h7v2H5v14h7v2H5a2 2 0 0 1-2-2V5Z",
            "M18.414 9A1 1 0 1 0 17 10.414l.586.586H8a1 1 0 1 0 0 2h9.586l-.586.586A1 1 0 0 0 18.414 15l2.293-2.293a1 1 0 0 0 0-1.414L18.414 9Z"
        ],
        "markSent": [
            "M3.72 13.301a1 1 0 1 0-1.415 1.414l1.586 1.992a1 1 0 0 0 1.414 0l3.39-3.201a1 1 0 1 0-1.414-1.414l-2.683 2.494-.879-1.285Z",
            "M6 10V7.414l6.293 6.293a1 1 0 0 0 1.414 0L20 7.414V17a1 1 0 0 1-1 1H4.17A3.001 3.001 0 0 0 7 20h12a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v3h2Zm7 1.586L7.414 6h11.172L13 11.586Z"
        ],
        "marketing": [
            "M19 4.024c0-.91-1.1-1.366-1.742-.723L16.121 4.44A8.65 8.65 0 0 1 10 6.979H5c-1.657 0-3 1.345-3 3.004v2.003a3.002 3.002 0 0 0 3 3.004v4.006A3.002 3.002 0 0 0 8 22c1.657 0 3-1.345 3-3.004v-3.948a8.652 8.652 0 0 1 5.121 2.481l1.137 1.139c.643.643 1.742.188 1.742-.723v-3.081a4.006 4.006 0 0 0 3-3.88 4.006 4.006 0 0 0-3-3.879V4.024Zm0 5.226a2.003 2.003 0 0 1 0 3.47V9.25ZM7 18.996V14.99h2v4.006a1 1 0 1 1-2 0Zm10-3.384a10.65 10.65 0 0 0-6-2.578v-4.1a10.65 10.65 0 0 0 6-2.577v9.255Zm-8-2.625H5a1 1 0 0 1-1-1.001V9.983a1 1 0 0 1 1-1.001h4v4.005Z"
        ],
        "menu": [
            "M4 7a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm0 10a1 1 0 0 0 1 1h10a1 1 0 1 0 0-2H5a1 1 0 0 0-1 1Zm14.414-8A1 1 0 1 0 17 10.414l.586.586H5a1 1 0 1 0 0 2h12.586l-.586.586A1 1 0 0 0 18.414 15l2.293-2.293a1 1 0 0 0 0-1.414L18.414 9Z"
        ],
        "minus": [
            "M12.047 1.616c-5.606 0-10.15 4.545-10.15 10.149 0 5.606 4.545 10.15 10.15 10.15s10.15-4.545 10.15-10.15-4.545-10.15-10.15-10.15Zm6.102 8.914v2.471H5.945v-2.47H18.15Z"
        ],
        "minus2": [
            "M18.329 10.557H5.764c-.668 0-.725.541-.725 1.208 0 .667.057 1.208.725 1.208H18.33c.668 0 .726-.541.726-1.208 0-.667-.058-1.208-.726-1.208Z"
        ],
        "money": [
            "M7 11h6a1 1 0 1 0 0-2H7a1 1 0 0 0 0 2Z",
            "M2 4a2 2 0 0 1 2-2h12a1 1 0 1 1 0 2H4.5a.5.5 0 0 0-.5.5V5h14a2 2 0 0 1 2 2v4.05a2.5 2.5 0 0 1 0 4.9V19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Zm16 7V7.5a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V16h-.5a2.5 2.5 0 0 1 0-5h.5Zm1.5 2h-2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1Z"
        ],
        "more": [
            "M4 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm6 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm8-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
        ],
        "moveMarker": [
            "M4 12a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm2 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
            "m13.84 21.51-.066.09a.952.952 0 0 1-1.548 0l-.066-.09c-.777-1.07-1.979-2.725-3.116-4.51h2.228A57.251 57.251 0 0 0 13 19.5s5-6.739 5-9.5a5 5 0 0 0-10 0H6a7 7 0 0 1 14 0c0 3.03-4.3 8.95-6.16 11.51Z",
            "M11 10a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"
        ],
        "moveVisits": [
            "M4 4a2 2 0 0 0-2 2h10v10h-1.17a3.001 3.001 0 0 0-5.66 0H2a2 2 0 0 0 2 2h1.17a3.001 3.001 0 0 0 5.66 0h3.34a3.001 3.001 0 0 0 5.66 0H20a2 2 0 0 0 2-2v-6l-2.903-4.147A2 2 0 0 0 17.46 5h-3.727A2 2 0 0 0 12 4H4Zm15.83 12a3.001 3.001 0 0 0-5.66 0H14v-4h6v4h-.17ZM9 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm8.25-10L19 10h-5V7h3.25ZM18 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
            "M2 8a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1Zm2 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Z"
        ],
        "note": [
            "M4 4a2 2 0 0 1 2-2h8.586A2 2 0 0 1 16 2.586L19.414 6A2 2 0 0 1 20 7.414V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm2 0v16h12V7.414L14.586 4H6Z"
        ],
        "offline": [
            "M18.17 10.714h.973A2.852 2.852 0 0 1 22 13.571c0 1.36-.713 2.555-1.786 3.229l1.438 1.438A5.8 5.8 0 0 0 24 13.57a4.859 4.859 0 0 0-3.953-4.773 7.24 7.24 0 0 0-11.85-4.016L9.614 6.2a5.239 5.239 0 0 1 8.554 4.514Zm-.79 8.666h-5.856l-.095.001h-5.62a5.81 5.81 0 0 1-.047-11.619L4.707 6.707a1 1 0 1 1 1.414-1.414l14.586 14.586a1 1 0 0 1-1.414 1.414L17.38 19.38ZM7.739 9.739l-.002.024H5.81a3.81 3.81 0 1 0 0 7.619h5.619c.031 0 .063 0 .095-.002a2 2 0 0 0 .095.002h3.762L7.738 9.738Z"
        ],
        "onlineBooking": [
            "M7 3v1H5a2 2 0 0 0-2 2v3a1 1 0 0 0 2 0V6h15v2h-8a1 1 0 1 0 0 2h8v7h-7a1 1 0 1 0 0 2h7a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V3a1 1 0 1 0-2 0v1H9V3a1 1 0 0 0-2 0Z",
            "M10.628 12.303 8.822 7.639c-.223-.852-1.474-.852-1.698 0l-1.752 4.663-2.903 1.37a.835.835 0 0 0 0 1.5l2.903 1.37L7.15 21.36c.224.852 1.475.852 1.698 0l1.78-4.82 2.902-1.368a.835.835 0 0 0 0-1.502l-2.903-1.368Zm-6.132 2.12 1.752-.849.876-.848L8 10.183l.876 2.543.876.848 1.752.848-1.752.848-.876.848L8 18.662l-.876-2.544-.876-.848-1.752-.848Z"
        ],
        "paidInvoice": [
            "M8 2a2 2 0 0 0-2 2v4h2V4h8.586L20 7.414V20H8v-3H6v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.414A2 2 0 0 0 21.414 6L18 2.586A2 2 0 0 0 16.586 2H8Z",
            "M13.977 9c.026 0 .65.04 1.316.707a1 1 0 0 0 1.414-1.414A4.487 4.487 0 0 0 15 7.2V7a1 1 0 0 0-2 0v.184A2.996 2.996 0 0 0 11 10c0 2.28 1.727 2.713 2.758 2.97C14.873 13.25 15 13.354 15 14c0 .552-.448 1-.976 1-.026 0-.65-.04-1.317-.707a1 1 0 1 0-1.414 1.415A4.502 4.502 0 0 0 13 16.798v.2a1 1 0 0 0 2 0v-.184A2.995 2.995 0 0 0 17 14c0-2.28-1.726-2.712-2.757-2.97C13.128 10.752 13 10.646 13 10c0-.55.45-1 .977-1Zm-5.684 2.707a1 1 0 1 0-1.414-1.414l-2.586 2.586-.586-.586a1 1 0 0 0-1.414 1.414L3.586 15A1 1 0 0 0 5 15l3.293-3.293Z"
        ],
        "paperclip": [
            "M13.982 4.853a4.461 4.461 0 1 1 6.358 6.26l-7.833 7.913a6.093 6.093 0 1 1-8.625-8.608L9.54 4.797a1 1 0 1 1 1.41 1.419l-5.658 5.62a4.093 4.093 0 1 0 5.793 5.783l7.833-7.914a2.461 2.461 0 1 0-3.507-3.453l-7.473 7.63a.778.778 0 0 0 1.109 1.092l7.193-7.267a1 1 0 0 1 1.421 1.407l-7.193 7.267a2.778 2.778 0 0 1-3.959-3.898l7.473-7.63Z"
        ],
        "payment": [
            "M13 13a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Z",
            "M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H4Zm16 2v2H4V7h16ZM4 17v-6h16v6H4Z"
        ],
        "pdf": [
            "M12.038 10.807c.487-1.64.553-2.779.155-3.347-.199-.307-.53-.46-.907-.46-.442 0-.796.197-.95.59-.332.767.176 2.167.774 3.305a17.46 17.46 0 0 1-.642 1.75c-.133.35-.31.7-.486 1.029-1.327.503-2.787 1.27-2.963 2.188a.901.901 0 0 0 .353.92.877.877 0 0 0 .597.218c.089 0 .177-.022.266-.044.818-.197 1.68-1.4 2.344-2.582a22.18 22.18 0 0 1 1.282-.416 21.548 21.548 0 0 1 1.504-.372c.818.657 1.548 1.007 2.167 1.007.442.022.84-.153 1.15-.481.487-.482.288-.92.221-1.05-.354-.591-1.548-.723-3.295-.395a35.2 35.2 0 0 1-.884-.897 5.224 5.224 0 0 1-.686-.963Zm-4.157 5.208c.044-.219.464-.634 1.371-1.072-.464.657-.907 1.116-1.216 1.182-.067.022-.089 0-.155-.11Zm3.233-8.083c.018-.038.027-.057.15-.057.133 0 .177.044.2.088.154.219.154.788-.023 1.685-.287-.744-.464-1.423-.332-1.707l.005-.01Zm.423 5.224a4.788 4.788 0 0 0-.405.124c.044-.11.088-.219.132-.306l.091-.23c.123-.31.24-.605.33-.886a5.025 5.025 0 0 0 .397.503c.177.175.354.35.51.525-.288.066-.62.153-.952.24l-.103.03Zm4.04.562c-.266 0-.62-.132-.996-.35 1.084-.11 1.637-.066 1.526.13-.11.198-.287.22-.53.22Z",
            "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.414A2 2 0 0 0 19.414 6L16 2.586A2 2 0 0 0 14.586 2H6Zm0 18V4h8.586L18 7.414V20H6Z"
        ],
        "percent": [
            "M18.707 5.29a.997.997 0 0 1 0 1.414L6.703 18.708a.997.997 0 0 1-1.414 0 .996.996 0 0 1 0-1.414L17.293 5.29a.996.996 0 0 1 1.414 0ZM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm11 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
        ],
        "person": [
            "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM5.29 19h13.42a7.004 7.004 0 0 0-13.42 0Zm-2.245.016C3.949 15 7.711 12 12 12s8.054 3 8.957 7.016a1.567 1.567 0 0 1 .022.574c-.124.807-.901 1.41-1.802 1.41H4.825c-.914 0-1.701-.622-1.807-1.447a1.543 1.543 0 0 1 .027-.537Z"
        ],
        "phone": [
            "M2.007 5.06C1.89 3.35 3.3 2 4.947 2h2.368a3.004 3.004 0 0 1 2.95 2.4l.458 2.268A2.471 2.471 0 0 1 9.39 9.369a.429.429 0 0 0-.197.19.198.198 0 0 0-.014.156c.587 1.765 2.087 4.156 5.01 5.021a.248.248 0 0 0 .184-.02.452.452 0 0 0 .2-.204 2.5 2.5 0 0 1 2.722-1.32l2.285.453A2.992 2.992 0 0 1 22 16.573v2.558c0 1.492-1.149 2.876-2.799 2.869-3.168-.013-7.23-.854-10.634-3.418-3.44-2.59-6.106-6.864-6.56-13.521Zm2.94-1.07c-.568 0-.972.454-.939.936.42 6.14 2.838 9.86 5.772 12.07 2.968 2.236 6.569 3.002 9.43 3.013.394.002.784-.34.784-.878v-2.558a.997.997 0 0 0-.807-.976l-2.284-.454a.491.491 0 0 0-.534.26c-.476.943-1.586 1.586-2.752 1.241-3.775-1.116-5.635-4.179-6.342-6.304-.39-1.169.27-2.28 1.22-2.752a.485.485 0 0 0 .26-.53L8.3 4.791a1.001 1.001 0 0 0-.984-.8H4.947Z"
        ],
        "pinned": [
            "M14.607 3.293a1 1 0 1 0-1.415 1.414l.707.707-3.242 3.243H4a1 1 0 0 0-.707 1.707l4.596 4.596-3.535 3.536a1 1 0 1 0 1.414 1.414l3.535-3.536 4.596 4.597a1 1 0 0 0 1.708-.707v-6.657l3.242-3.243.99.99a1 1 0 0 0 1.415-1.414l-6.647-6.647Z"
        ],
        "plus": [
            "M12.047 1.616c-5.606 0-10.15 4.545-10.15 10.149 0 5.606 4.545 10.15 10.15 10.15s10.15-4.545 10.15-10.15-4.545-10.15-10.15-10.15ZM13.282 13v4.865h-2.47V13H5.945v-2.47h4.866V5.663h2.47v4.866h4.866v2.47h-4.865Z"
        ],
        "plus2": [
            "M12 3a1 1 0 0 0-1 1v7H4a1 1 0 1 0 0 2h7v7a1 1 0 1 0 2 0v-7h7a1 1 0 1 0 0-2h-7V4a1 1 0 0 0-1-1Z"
        ],
        "presentation": [
            "M2.015 5.012v11.011c0 1.106.896 2.002 2.002 2.002H20.02a2.002 2.002 0 0 0 2.001-2.002V5.013A2.002 2.002 0 0 0 20.02 3.01H4.018a2.002 2.002 0 0 0-2.002 2.001Zm2.002 0H20.02v11.011H4.017V5.013Zm2.61 16.016a1 1 0 0 1 1.002-1h8.766a1.001 1.001 0 1 1 0 2.001H7.629a1.001 1.001 0 0 1-1.001-1Zm7.489-11.667a2.104 2.104 0 1 1-4.208 0 2.104 2.104 0 0 1 4.208 0Zm2.76 6.662H7.143c0-.473 1.296-3.656 4.87-3.656s4.865 3.184 4.865 3.656Z"
        ],
        "printer": [
            "M18 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
            "M6 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4h2a2 2 0 0 1 2 2v8h-5v2a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-2H2v-8a2 2 0 0 1 2-2h2V4Zm10 0H8v4h8V4Zm-1 12H9v4h6v-4Zm-8-2h10v2h3v-6H4v6h3v-2Z"
        ],
        "property": [
            "M19.394 11c.917 0 1.35-1.13.669-1.743l-7.394-6.655a1 1 0 0 0-1.338 0L3.937 9.257C3.256 9.87 3.689 11 4.606 11H5v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-9h.394ZM17 9.197V20h-2v-3.385a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2V20H7V9.197l5-4.506 5 4.506ZM11 16v1h2v3h-2v-4Z"
        ],
        "quickbooks": [
            "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm2.779 6.112h.555a3.888 3.888 0 1 1 0 7.778h-2.78V5.445c.799 0 1.445.647 1.445 1.445v7.554h1.335a2.447 2.447 0 0 0 2.445-2.443 2.447 2.447 0 0 0-2.445-2.445h-.555V8.112Zm-6.113 7.777a3.888 3.888 0 1 1 0-7.778h2.78v10.445A1.445 1.445 0 0 1 10 17.11V9.556H8.666A2.447 2.447 0 0 0 6.22 12a2.447 2.447 0 0 0 2.445 2.444h.555v1.445h-.555Z"
        ],
        "quote": [
            "M14 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z",
            "M3.586 6C3.196 6.39 3 6.902 3 7.414c0 .512.195 1.024.586 1.414l.99.991C4.315 10.554 4 11.175 4 12a7 7 0 0 0 7 7h9v1a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1h-3v-5a7 7 0 0 0-7-7c-.825 0-1.446.314-2.18.577l-.992-.991A1.994 1.994 0 0 0 6.414 4c-.512 0-1.023.195-1.414.586L3.586 6Zm3.393.565A7.041 7.041 0 0 0 5.565 7.98L5 7.414 6.414 6l.565.565ZM11 7a5 5 0 0 1 5 5v5h-5a5 5 0 0 1 0-10Z"
        ],
        "recurring": [
            "M7.007 2.933a1 1 0 0 0-1.001 1v1.002H5.005a2.002 2.002 0 0 0-2.002 2.001v9.01c0 1.105.896 2.001 2.002 2.001h11.01a2.002 2.002 0 0 0 2.002-2.002V6.936a2.002 2.002 0 0 0-2.001-2.002h-1.001v-1a1.001 1.001 0 1 0-2.002 0v1H8.008v-1c0-.553-.448-1.002-1.001-1.002Zm9.009 4.003v2.002H5.005V6.936h11.01Zm-11.011 9.01V10.94h11.01v5.005H5.006Zm2.002 5.004a2.002 2.002 0 0 1-2.002-2.002h13.013a1 1 0 0 0 1-1V6.935c1.106 0 2.003.897 2.003 2.002v10.01a2.002 2.002 0 0 1-2.002 2.002H7.007Z"
        ],
        "redo": [
            "M13 19A7 7 0 1 0 7.255 8H9a1 1 0 0 1 0 2H5a.997.997 0 0 1-.702-.288l-.006.005.002-.008A.997.997 0 0 1 4 9V5a1 1 0 0 1 2 0v1.343a9 9 0 1 1 3.496 13.95c-.598-.254-.693-1.025-.234-1.484l.053-.053c.307-.306.773-.374 1.177-.219A6.983 6.983 0 0 0 13 19ZM6.01 8h.012l-.006-.006L6.009 8Z"
        ],
        "reminder": [
            "M11 3a1 1 0 1 1 2 0v1a.977.977 0 0 1-.003.082A6.002 6.002 0 0 1 18 10v6l1.793 1.793a.707.707 0 0 1-.5 1.207H4.707a.707.707 0 0 1-.5-1.207L6 16v-6a6.002 6.002 0 0 1 5.003-5.918A.977.977 0 0 1 11 4V3Zm1 3a4 4 0 0 0-4 4v7h8v-7a4 4 0 0 0-4-4Zm2 14a2 2 0 1 1-4 0h4Z"
        ],
        "reports": [
            "M3 4v16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7.767a2 2 0 0 0-.513-1.337l-3.391-3.768A2 2 0 0 0 15.609 2H5a2 2 0 0 0-2 2Zm2 13.414 3-3 1.793 1.793a1 1 0 0 0 1.414 0L15 12.414V13a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1h-3a1 1 0 1 0 0 2h.586L10.5 14.086l-1.793-1.793a1 1 0 0 0-1.414 0L5 14.586V4h10.61L19 7.767V20H5v-2.586Z"
        ],
        "request": [
            "M12 2a1 1 0 0 0-1 1v5.586L9.707 7.285A.998.998 0 0 0 8 8c.002.253.1.506.293.699l3 3.008a.997.997 0 0 0 1.414 0l3.022-3.293a.996.996 0 0 0 0-1.414.997.997 0 0 0-1.414 0L13 8.586V3a1 1 0 0 0-1-1Z",
            "M2 5a2 2 0 0 1 2-2h4v2H4v9h5a1 1 0 0 1 .894.553L10.618 16h2.764l.724-1.447A1 1 0 0 1 15 14h5V5h-4V3h4a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm18 11h-4.382l-.724 1.447A1 1 0 0 1 14 18h-4a1 1 0 0 1-.894-.553L8.382 16H4v4h16v-4Z"
        ],
        "runningTimer": [
            "M12 6a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1Z",
            "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm0-18a8 8 0 1 1 0 16 8 8 0 0 1 0-16Z"
        ],
        "schedule": [
            "M7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3-9a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2h-8Zm-1 5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z",
            "M4 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4Zm16 2v14H4V5h16Z"
        ],
        "search": [
            "M15.906 17.32a8 8 0 1 1 1.414-1.414l3.387 3.387a1 1 0 0 1-1.414 1.414l-3.387-3.387ZM17 11a6 6 0 1 0-12 0 6 6 0 0 0 12 0Z"
        ],
        "sendInvoice": [
            "M13.977 9c.026 0 .65.04 1.316.707a1 1 0 0 0 1.414-1.414A4.487 4.487 0 0 0 15 7.2V7a1 1 0 0 0-2 0v.184A2.996 2.996 0 0 0 11 10c0 2.28 1.727 2.713 2.758 2.97C14.873 13.25 15 13.354 15 14c0 .552-.448 1-.976 1-.026 0-.65-.04-1.317-.707a1 1 0 1 0-1.414 1.415A4.502 4.502 0 0 0 13 16.798v.2a1 1 0 0 0 2 0v-.184A2.995 2.995 0 0 0 17 14c0-2.28-1.726-2.712-2.757-2.97C13.128 10.752 13 10.646 13 10c0-.55.45-1 .977-1Z",
            "M8 2a2 2 0 0 0-2 2v2h2V4h8.586L20 7.414V20H8v-2H6v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.414A2 2 0 0 0 21.414 6L18 2.586A2 2 0 0 0 16.586 2H8Z",
            "M2 11a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm2 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm2-8h2v2H6V6Zm0 11h2v1H6v-1Z"
        ],
        "sendMessage": [
            "m5.132 21.164 15.292-7.693a1.6 1.6 0 0 0 .672-.596c.165-.26.252-.563.254-.872V12a1.669 1.669 0 0 0-.25-.872 1.616 1.616 0 0 0-.666-.603L5.134 2.83a1.677 1.677 0 0 0-1.964.328 1.75 1.75 0 0 0-.49.93 1.77 1.77 0 0 0 .127 1.05v.001L5.86 12l-3.053 6.86v.002a1.775 1.775 0 0 0-.128 1.05c.065.353.235.678.49.93a1.65 1.65 0 0 0 1.196.509l.005-.001c.265-.004.525-.068.762-.187Zm2.096-9.956L4.232 4.487v-.001a.174.174 0 0 1-.012-.103.164.164 0 0 1 .046-.088l.006-.006a.146.146 0 0 1 .099-.044c.022 0 .043.006.064.016l13.842 6.949H7.228ZM4.22 19.62a.174.174 0 0 1 .012-.103l2.996-6.723h11.05l-13.845 6.95a.135.135 0 0 1-.16-.03l-.007-.006a.165.165 0 0 1-.046-.088Z"
        ],
        "share": [
            "M20 7a3 3 0 0 1-5.01 2.227l-4.072 1.963a4.022 4.022 0 0 1-.01 1.665l3.968 2.026a3 3 0 1 1-.86 1.812l-4.022-2.04a4 4 0 1 1 .062-5.234l3.982-1.943A3 3 0 1 1 20 7Zm-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-9.863 3.354a2 2 0 0 0-3.134 1.761v.007a2 2 0 1 0 3.134-1.768ZM17 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        ],
        "signature": [
            "M9 13.83a2 2 0 0 1 .586-1.413l7.83-7.831a1.996 1.996 0 0 1 2.829 0l1.172 1.171c.365.366.56.838.583 1.317a1.995 1.995 0 0 1-.583 1.512l-7.831 7.83a2 2 0 0 1-1.414.586H9v-3.171Zm3.172 1.172 7.83-7.83L18.831 6 11 13.83v1.172h1.172Zm-6.39 2c-.33 0-.65.091-.957.226h-.001c-.261.116-.52.268-.776.442a7.548 7.548 0 0 0-.75.589c-.375.343-.398 1.073-.058 1.445l.002.002a.917.917 0 0 0 1.294.055c.108-.099.306-.263.546-.426a3.18 3.18 0 0 1 .482-.279c.067-.029.12-.047.161-.058.04-.01.057-.012.057-.012.038 0 .17.025.415.125.227.093.503.231.804.404.554.32 1.179.487 1.817.487h4.19c.506 0 .916-.41.916-.916s-.418-1.084-.924-1.084H8.819a1.8 1.8 0 0 1-.903-.242l-.001-.001c-.756-.434-1.503-.757-2.133-.757Z"
        ],
        "sliderCenter": [
            "M21.707 5.707A.996.996 0 0 0 22 5.048v-.059a.995.995 0 0 0-.293-.696l-2-2a1 1 0 1 0-1.414 1.414l.293.293H16a1 1 0 1 0 0 2h2.586l-.293.293a1 1 0 0 0 1.414 1.414l2-2ZM11 10H4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h7v2a1 1 0 1 0 2 0v-2h7a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-7V8a1 1 0 1 0-2 0v2Zm0 2v5H4v-5h7Zm2 0h7v5h-7v-5ZM8 6H5.414l.293.293a1 1 0 0 1-1.414 1.414l-2-2a.997.997 0 0 1-.002-1.412l.002-.002 2-2a1 1 0 0 1 1.414 1.414L5.414 4H8a1 1 0 1 1 0 2Z"
        ],
        "sliderStart": [
            "M8 8a1 1 0 0 0-2 0v2H4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h2v2a1 1 0 1 0 2 0v-2h12a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2H8V8Zm-2 4v5H4v-5h2Zm2 5v-5h12v5H8Zm6.707-9.293 2-2a1 1 0 0 0 0-1.415l-2-2a1 1 0 1 0-1.414 1.415l.293.293H11a1 1 0 1 0 0 2h2.586l-.293.293a1 1 0 0 0 1.414 1.414Z"
        ],
        "sms": [
            "M3 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4h5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-5v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4Zm10 13.603-1.35 1.156A1 1 0 0 1 10 18v-2H8a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h5V7H5v13h8v-2.397ZM5 4v1h8V4H5Zm4 10h3v1.826L14.13 14H19v-4H9v4Z"
        ],
        "sms2": [
            "M4 2a2 2 0 0 0-2 2v15.586c0 .89 1.077 1.337 1.707.707L6 18h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm16 2v12H5l-1 1V4h16ZM6 7a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1 2a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H7Zm0 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H7Z"
        ],
        "sneaker": [
            "M6 11.014c.552 0 1-.45 1-1.003a1.001 1.001 0 1 0-1 1.003Z",
            "M10.575 5.045c.392-.049.79.02 1.143.196l9.176 4.6A2.005 2.005 0 0 1 22 11.632v3.39a3.003 3.003 0 0 1-3 3.007H5c-1.657 0-3-1.346-3-3.007V7.889c0-1.01.751-1.863 1.752-1.989l6.824-.855ZM5 16.025h14c.552 0 1-.449 1-1.002H4c0 .553.448 1.002 1 1.002Zm15-4.392-3.225-1.616-.346.868a1 1 0 1 1-1.857-.745l.408-1.023-.622-.311-.43 1.076a1 1 0 1 1-1.857-.744l.492-1.232-1.74-.872L4 7.89v5.13h16v-1.386Z"
        ],
        "sort": [
            "M16 8a2 2 0 0 1 2 2v1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-1a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h10Zm-.5 3a.5.5 0 0 0 0-1h-9a.5.5 0 0 0 0 1h9ZM8 13v1h10v-1H8Zm3.293-9.707a.997.997 0 0 1 1.414 0l2.293 2a1 1 0 0 1-1.414 1.414L12 5.414l-1.586 1.293A1 1 0 1 1 9 5.293l2.293-2ZM12 18.586l-1.586-1.293a.997.997 0 0 0-1.414 0 1 1 0 0 0 0 1.414l2.293 2a.997.997 0 0 0 1.414 0l2.293-2a1 1 0 0 0-1.414-1.414L12 18.586Z"
        ],
        "sparkles": [
            "M6 2a1 1 0 0 1 1 1v1l1 1h1a1 1 0 1 1 0 2H8L7 8v1a1 1 0 1 1-2 0V8L4 7H3a1 1 0 1 1 0-2h1l1-1V3a1 1 0 0 1 1-1Zm1 12a1 1 0 0 1 1 1v1l1 1h1a1 1 0 1 1 0 2H9l-1 1v1a1 1 0 1 1-2 0v-1l-1-1H4a1 1 0 1 1 0-2h1l1-1v-1a1 1 0 0 1 1-1Zm7-10c.255-1.005 1.683-1.005 1.938 0L18 9.5l3.314 1.615a1 1 0 0 1 0 1.77L18 14.5l-2.03 5.684c-.256 1.005-1.684 1.005-1.94 0L12 14.5l-3.314-1.615a1 1 0 0 1 0-1.77L12 9.5 14 4Zm-3 8 2 1 1 1 1 3 1-3 1-1 2-1-2-1-1-1-1-3-1 3-1 1-2 1Z"
        ],
        "star": [
            "m15.673 13.337 3.673-3.58-5.076-.738-2.27-4.6-2.27 4.6-5.076.738 3.673 3.58-.867 5.176L12 16.006l4.54 2.386-.867-5.055ZM12 18.335l-4.505 2.49a1.546 1.546 0 0 1-2.244-1.63l.86-5.137-3.644-3.553a1.546 1.546 0 0 1 .857-2.637l5.037-.732 2.252-4.273a1.547 1.547 0 0 1 2.774 0l2.252 4.273 5.037.732a1.546 1.546 0 0 1 .857 2.637l-3.645 3.553.86 5.139a1.547 1.547 0 0 1-2.243 1.63L12 18.334Z"
        ],
        "starFill": [
            "m12 18.626-4.505 2.196a1.546 1.546 0 0 1-2.244-1.63l.86-4.843-3.644-3.553a1.546 1.546 0 0 1 .857-2.637l5.037-.732 2.252-4.564a1.547 1.547 0 0 1 2.774 0l2.252 4.564 5.037.732a1.546 1.546 0 0 1 .857 2.637l-3.645 3.553.86 4.844a1.547 1.547 0 0 1-2.243 1.63L12 18.626Z"
        ],
        "starHalf": [
            "M15.6728 13.3369L19.3458 9.75693L14.2698 9.01893L11.9998 4.41993V16.0059L16.5398 18.3919L15.6728 13.3369ZM11.9998 18.3349L7.49485 20.8259C7.23947 20.9604 6.95153 21.0207 6.66365 21C6.37576 20.9793 6.09941 20.8785 5.86589 20.7088C5.63236 20.5392 5.45098 20.3076 5.34229 20.0402C5.23359 19.7728 5.20192 19.4804 5.25085 19.1959L6.11085 14.0579L2.46685 10.5049C2.26027 10.3036 2.11416 10.0484 2.04504 9.76833C1.97591 9.48825 1.98653 9.19442 2.0757 8.92006C2.16486 8.6457 2.32901 8.40176 2.54959 8.21583C2.77016 8.02989 3.03836 7.90939 3.32385 7.86793L8.36085 7.13593L10.6128 2.8631C10.7404 2.60408 10.9379 2.38594 11.183 2.23339C11.4282 2.08085 11.7111 2 11.9998 2C12.2886 2 12.5715 2.08085 12.8167 2.23339C13.0618 2.38594 13.2593 2.60408 13.3868 2.8631L15.6388 7.13593L20.6758 7.86793C20.9613 7.90939 21.2295 8.02989 21.4501 8.21583C21.6707 8.40176 21.8348 8.6457 21.924 8.92006C22.0132 9.19442 22.0238 9.48825 21.9547 9.76833C21.8855 10.0484 21.7394 10.3036 21.5328 10.5049L17.8878 14.0579L18.7478 19.1965C18.7966 19.4809 18.7649 19.7732 18.6563 20.0404C18.5476 20.3076 18.3663 20.5391 18.133 20.7087C17.8996 20.8783 17.6235 20.9792 17.3357 21C17.048 21.0208 16.7602 20.9608 16.5048 20.8265L11.9998 18.3349Z"
        ],
        "starburst": [
            "M12 2a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1Zm0 14a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1ZM2 12a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm15-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4ZM5.292 5.292a.997.997 0 0 1 1.414 0l2.002 2.002a.997.997 0 0 1 0 1.414.996.996 0 0 1-1.414 0L5.292 6.707a.996.996 0 0 1 0-1.415Zm13.416 0a.997.997 0 0 0-1.414 0l-2.002 2.002a.997.997 0 0 0 0 1.414.996.996 0 0 0 1.414 0l2.002-2.001a.996.996 0 0 0 0-1.415ZM5.292 18.708a.997.997 0 0 0 1.414 0l2.002-2.002a.997.997 0 0 0 0-1.414.996.996 0 0 0-1.414 0l-2.002 2.001a.997.997 0 0 0 0 1.415Zm13.416-.048a.997.997 0 0 1-1.414 0l-2.002-1.954a.997.997 0 0 1 0-1.414.996.996 0 0 1 1.414 0l2.002 1.954a.996.996 0 0 1 0 1.415Z"
        ],
        "sun": [
            "M12 7c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1Zm4.58 8H19a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h2.42A4.94 4.94 0 0 1 7 13c0-2.76 2.24-5 5-5s5 2.24 5 5c0 .71-.15 1.39-.42 2ZM12 10c-1.66 0-3 1.34-3 3 0 .77.3 1.47.78 2h4.44c.48-.53.78-1.23.78-2 0-1.66-1.34-3-3-3Zm-5 9a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z",
            "M5 14H3c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1Zm14 0c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1h-2ZM7.71 8.709A.995.995 0 0 1 6.95 9a1.021 1.021 0 0 1-.66-.291l-2.05-2.06a1 1 0 0 1 1.41-1.41l2.06 2.05A.972.972 0 0 1 8 8.14a.992.992 0 0 1-.28.559l-.01.01Z",
            "M7.71 8.709A.995.995 0 0 1 6.95 9a1.021 1.021 0 0 1-.66-.291l-2.05-2.06a1 1 0 0 1 1.41-1.41l2.06 2.05A.972.972 0 0 1 8 8.14a.992.992 0 0 1-.28.559l-.01.01Zm8.58 0a.996.996 0 0 0 .76.291 1.02 1.02 0 0 0 .66-.291l2.05-2.06a1 1 0 0 0-1.41-1.41l-2.06 2.05a.974.974 0 0 0-.29.851c.03.205.124.402.28.559l.01.01Z",
            "M16.29 8.709a.996.996 0 0 0 .76.291 1.02 1.02 0 0 0 .66-.291l2.05-2.06a1 1 0 0 0-1.41-1.41l-2.06 2.05a.974.974 0 0 0-.29.851c.03.205.124.402.28.559l.01.01Z"
        ],
        "sync": [
            "M9.65 3.384a1 1 0 0 1 1.403-.172l2.556 1.996a1 1 0 0 1 .172 1.404l-1.996 2.555a1 1 0 0 1-1.576-1.231l.386-.598a5.002 5.002 0 0 0-1.851 8.592l-1.418 1.418A7.003 7.003 0 0 1 10.48 5.303l-.659-.515a1 1 0 0 1-.172-1.404Zm3.641 13.314.49-.627a1 1 0 1 0-1.576-1.231l-1.996 2.555a1 1 0 0 0 .172 1.404l2.555 1.996a1 1 0 0 0 1.231-1.576l-.659-.515a7.003 7.003 0 0 0 3.103-12.092l-1.419 1.419a5.002 5.002 0 0 1-1.901 8.667Z"
        ],
        "syncAlert": [
            "M11 5.07a7 7 0 0 1 6 11.828V16a1 1 0 1 0-2 0v3a1 1 0 0 0 1 1h3.5a1 1 0 1 0 0-2h-.792A9 9 0 0 0 11 3.055V5.07ZM12 19c.34 0 .673-.024 1-.07v2.015A9 9 0 0 1 5.292 6H4.5a1 1 0 0 1 0-2H8a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0v-.899A7 7 0 0 0 12 19Z",
            "M11 8a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V8Zm1 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
        ],
        "tableColumns": [
            "M19 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14ZM6 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2V6H6Zm4 12h4V6h-4v12Zm6 0h2a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-2v12Z"
        ],
        "tag": [
            "M2 7a2 2 0 0 1 2-2h11.809a2 2 0 0 1 1.506.685l4.364 5S22 11 22 12s-.32 1.315-.32 1.315l-4.365 5A2 2 0 0 1 15.81 19H4a2 2 0 0 1-2-2V7Zm13.809 0H4v10h11.809l4.364-5-4.364-5Z"
        ],
        "task": [
            "M9.72 13.305a1 1 0 1 0-1.415 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414l-3.293 3.293-1.293-1.293Z",
            "M9.293 2.293A1 1 0 0 1 10 2h4a1 1 0 0 1 .707.293L16.414 4H18a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1.586l1.707-1.707Zm5.414 5.414A1 1 0 0 1 14 8h-4a1 1 0 0 1-.707-.293L7.586 6H6v14h12V6h-1.586l-1.707 1.707ZM10.414 4l-1 1 1 1h3.172l1-1-1-1h-3.172Z"
        ],
        "textBox": [
            "M4 8a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm11 0a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1ZM5 11a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H5Zm6 1a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1Zm-7 4a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm10-1a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2h-5Z"
        ],
        "textField": [
            "M5 9a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2H5Zm11 0a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2h-3ZM4 14a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1Zm8-1a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2h-7Z"
        ],
        "thumbsUp": [
            "M8 11.78V19h8l3-5.76v-1.29h-7.639l1.036-7.944L8 11.78ZM6.134 11l4.555-8.034c1.124-1.846 3.971-.844 3.691 1.299l-.74 5.685h6.86a.5.5 0 0 1 .5.5v3a1 1 0 0 1-.084.4l-3.276 6.648a.95.95 0 0 1-.44.453c-.132.065-.276.049-.423.049H4c-1.105 0-2-1.045-2-2.15V13a2 2 0 0 1 2-2h2.134ZM6 13H4v6h2v-6Z"
        ],
        "timeline": [
            "M8 5a3.001 3.001 0 0 1-2 2.83v1.34a3.001 3.001 0 0 1 0 5.66v1.34a3.001 3.001 0 1 1-2 0v-1.34a3.001 3.001 0 0 1 0-5.66V7.83A3.001 3.001 0 1 1 8 5ZM5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm0 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm6-16a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-8Zm8 2v4h-8V5h8Zm-8 8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-8Zm8 2v4h-8v-4h8Z"
        ],
        "timer": [
            "M12 6a1 1 0 0 0-1 1v5.622l3.293 3.112a.996.996 0 0 0 1.415 0 .997.997 0 0 0 0-1.415L13 11.794V7a1 1 0 0 0-1-1Z",
            "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Z"
        ],
        "today": [
            "M16 3a1 1 0 0 0-1 1v1H9V4a1 1 0 0 0-2 0v1H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2V4a1 1 0 0 0-1-1Zm3 4v2H5V7h14ZM5 11h14v8H5v-8Zm11.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        ],
        "transfer": [
            "M15.293 2.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L17.586 8H4a1 1 0 0 1 0-2h13.586l-2.293-2.293a1 1 0 0 1 0-1.414ZM6.414 18l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L6.414 16H20a1 1 0 1 1 0 2H6.414Z"
        ],
        "trash": [
            "M9 11a1 1 0 1 1 2 0v6a1 1 0 1 1-2 0v-6Zm5-1a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1Z",
            "M8 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2h3a1 1 0 1 1 0 2h-1v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8H5a1 1 0 0 1 0-2h3V4Zm6 2V5h-4v1h4ZM8 8v12h8V8H8Z"
        ],
        "twitter": [
            "M19.18 4h-1.384l-5.072 5.883L8.671 4H4l6.126 8.896L4 20h1.384l5.357-6.212L15.019 20h4.672l-6.353-9.225L19.18 4ZM5.883 5.04H8.01l9.787 13.968H15.67L5.883 5.04Z"
        ],
        "unPinned": [
            "M13.192 3.293a1 1 0 0 1 1.415 0l6.647 6.647a1 1 0 0 1-1.414 1.414l-.99-.99-3.243 3.243v6.657a1 1 0 0 1-1.707.707l-4.597-4.597-3.535 3.536a1 1 0 0 1-1.414-1.414l3.535-3.536-4.596-4.596A1 1 0 0 1 4 8.657h6.657l3.242-3.243-.707-.707a1 1 0 0 1 0-1.414Zm2.122 3.535-3.536 3.536a1 1 0 0 1-.707.293H6.414l7.193 7.192v-4.657a1 1 0 0 1 .293-.707l3.535-3.535-2.121-2.122Z"
        ],
        "unscheduled": [
            "M19 9h-5.258l2.357 2H19v2.46l2 1.697V7a2 2 0 0 0-2-2h-2V4a1 1 0 1 0-2 0v1H9.026l2.358 2H19v2ZM3.483 5.696l-.857-.736A1 1 0 1 1 3.93 3.443l18.399 15.79a1 1 0 0 1-1.303 1.518l-.514-.441c-.366.423-.907.69-1.511.69H5a2 2 0 0 1-2-2V7c0-.498.182-.954.483-1.304ZM18.985 19l-9.322-8H5v8h13.985ZM7.333 9l-2.33-2L5 9h2.333Z"
        ],
        "upload": [
            "M2 10.5C2 13.538 4.686 16 8 16v-2c-2.21 0-4-1.567-4-3.5S5.79 7 8 7a4.5 4.5 0 0 1 1.414.225A4 4 0 0 1 17 9h.5a2.5 2.5 0 0 1 0 5H16v2h1.5a4.5 4.5 0 0 0 1.215-8.834A6.003 6.003 0 0 0 8.51 5.02 6.633 6.633 0 0 0 8 5c-3.314 0-6 2.462-6 5.5Z",
            "M12.707 9.293a1 1 0 0 0-1.414 0L9 11.586A1 1 0 0 0 10.414 13l.586-.586V18a1 1 0 1 0 2 0v-5.586l.586.586A1 1 0 0 0 15 11.586l-2.293-2.293Z"
        ],
        "user": [
            "M16 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-2 0a2 2 0 1 0-4 0 2 2 0 0 0 4 0Z",
            "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-10 8c1.47 0 2.846-.396 4.03-1.087-2.079-1.865-3.826-2.087-5.175-1.766-1.134.27-2.138.955-2.951 1.726A7.963 7.963 0 0 0 12 20Zm-1.608-4.799c2.206-.525 4.682.056 7.245 2.475a8 8 0 1 0-11.322-.047c1.018-1.016 2.396-2.028 4.077-2.428Z"
        ],
        "userSwitch": [
            "M8 6C6.348 6 5 7.348 5 9s1.348 3 3 3 3-1.348 3-3a3 3 0 0 0-3-3Zm0 4.154a1.154 1.154 0 1 1 0-2.309 1.154 1.154 0 0 1 0 2.309ZM13 9c0-1.652 1.348-3 3-3a3 3 0 1 1-3 3Zm1.846 0a1.154 1.154 0 1 0 2.309 0 1.154 1.154 0 0 0-2.309 0Zm6.65 10H15a5.99 5.99 0 0 0-.341-2h4.81A4.015 4.015 0 0 0 16 15c-.754 0-1.464.212-2.07.578a6.035 6.035 0 0 0-1.435-1.456A6.004 6.004 0 0 1 16 13c3.15 0 5.728 2.41 5.998 5.47.03.29-.21.53-.501.53Zm-19.495-.53A6.017 6.017 0 0 1 8 13c3.15 0 5.728 2.41 5.999 5.47.03.29-.211.53-.502.53H2.513A.505.505 0 0 1 2 18.47ZM11.47 17A4.015 4.015 0 0 0 8 15c-1.475 0-2.78.81-3.471 2h6.94Z"
        ],
        "userUnassigned": [
            "m5.14 4.724.01-.009L6.563 6.13a3.788 3.788 0 0 0-.009.009l1.937 1.937.007-.012 1.54 1.54c0 .006-.002.01-.003.016l2.345 2.344.014-.003 1.54 1.54a.624.624 0 0 1-.01.007l3.937 3.937.008-.01 1.415 1.416-.008.008.433.434A.998.998 0 0 1 19 21a.997.997 0 0 1-.704-.293l-.534-.533A9.954 9.954 0 0 1 12 22C6.477 22 2 17.523 2 12c0-2.146.676-4.133 1.826-5.762l-.534-.533a.997.997 0 0 1 0-1.415.996.996 0 0 1 1.415 0l.433.434Zm.126 2.955A7.963 7.963 0 0 0 4 12c0 2.195.884 4.183 2.315 5.629 1.018-1.016 2.396-2.028 4.077-2.428a6.413 6.413 0 0 1 2.266-.132l-1.093-1.092a4.001 4.001 0 0 1-3.542-3.542L5.266 7.68ZM12 20c1.47 0 2.846-.396 4.03-1.087-2.079-1.865-3.826-2.087-5.175-1.766-1.134.27-2.138.955-2.951 1.726A7.963 7.963 0 0 0 12 20ZM9.94 6.57l1.507 1.507a2 2 0 0 1 2.476 2.476l1.507 1.507a4 4 0 0 0-5.49-5.49Z",
            "M20 12c0 1.342-.33 2.606-.914 3.717l1.467 1.467A9.954 9.954 0 0 0 22 12c0-5.523-4.477-10-10-10a9.953 9.953 0 0 0-5.184 1.447l1.467 1.467A8 8 0 0 1 20 12Z"
        ],
        "vcard": [
            "M14 9a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm-1 7a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Zm1-4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm-6 2a3.008 3.008 0 0 0-3 2.735c-.01.145.11.265.256.265h5.492c.145 0 .266-.12.25-.265A3.008 3.008 0 0 0 8 14Zm0-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
            "M2 8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8Zm2 0v10h16V8H4Z"
        ],
        "video": [
            "M9 9a1 1 0 0 1 1.514-.857l5 3a1 1 0 0 1 0 1.714l-5 3A1 1 0 0 1 9 15V9Z",
            "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Z"
        ],
        "visit": [
            "M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h1.17a3.001 3.001 0 0 0 5.66 0h3.34a3.001 3.001 0 0 0 5.66 0H20a2 2 0 0 0 2-2v-6l-2.903-4.147A2 2 0 0 0 17.46 6h-3.727A2 2 0 0 0 12 5H4Zm15.83 12a3.001 3.001 0 0 0-5.66 0H14v-4h6v4h-.17ZM12 7v10h-1.17a3.001 3.001 0 0 0-5.66 0H4V7h8ZM9 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm8.25-10L19 11h-5V8h3.25ZM18 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
        ],
        "wallet": [
            "M17 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
            "M2 4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Zm2 4v12h16v-2h-6a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6V8H4Zm0-3a1 1 0 0 0 1 1h13V4H5a1 1 0 0 0-1 1Zm10 7v4h6v-4h-6Z"
        ],
        "word": [
            "M16.973 10.082a.865.865 0 1 0-1.686-.379l-1.138 4.665-.995-3.632a1 1 0 0 0-.965-.736h-.357a1 1 0 0 0-.961.726l-1.04 3.641-1.12-4.663a.863.863 0 1 0-1.684.37l1.556 5.172a1 1 0 0 0 .97.754h.536a1 1 0 0 0 .96-.719l.946-3.23.91 3.221a1 1 0 0 0 .963.728h.535a1 1 0 0 0 .967-.748l1.603-5.17Z",
            "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.414A2 2 0 0 0 19.414 6L16 2.586A2 2 0 0 0 14.586 2H6Zm0 18V4h8.586L18 7.414V20H6Z"
        ],
        "work": [
            "M9 3a2 2 0 0 0-2 2v2H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3V5a2 2 0 0 0-2-2H9Zm6 4H9V5h6v2Zm5 2v4h-5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2H4V9h16Zm0 6v5H4v-5h5v1a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-1h5Zm-9-2h2v3h-2v-3Z"
        ],
        "xero": [
            "M9.296 11.61v.017h3.14a1.617 1.617 0 0 0-3.14-.024v.007Z",
            "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM8.576 10.286l-1.703 1.71 1.701 1.709a.306.306 0 1 1-.437.426l-1.7-1.701-1.707 1.707a.306.306 0 1 1-.428-.436l1.702-1.706-1.703-1.705a.305.305 0 0 1 .214-.524c.081 0 .157.031.215.088l1.71 1.707 1.7-1.704a.306.306 0 0 1 .434.429Zm5.705-.228a1.27 1.27 0 0 1 .781-.264h.094-.002c.169 0 .306.137.306.306 0 .169-.129.293-.309.3-.005 0-.069 0-.129.006-.661.083-.732.396-.732 1.17v2.321a.305.305 0 0 1-.61 0v-3.775c0-.168.134-.304.301-.304a.31.31 0 0 1 .3.24Zm-4.705.115a2.25 2.25 0 0 1 2.494-.067c.518.329.86.841.99 1.465v-.001c.065.352-.17.661-.606.671H9.267l.005.047c.016.089.038.174.068.258.169.442.644 1.063 1.531 1.073.272-.002.527-.07.752-.19a1.76 1.76 0 0 0 .441-.356 1.8 1.8 0 0 0 .107-.14c.149-.191.338-.156.45-.07.134.103.157.319.035.47l-.002.002-.002.002-.004.005-.002.003a2.42 2.42 0 0 1-.573.543 2.208 2.208 0 0 1-.67.286 2.108 2.108 0 0 1-.804.054 2.258 2.258 0 0 1-1.9-1.675 2.266 2.266 0 0 1 .877-2.38Zm7.976 4.066a2.242 2.242 0 0 1 0-4.483 2.243 2.243 0 0 1 0 4.483Z",
            "M17.552 10.388a1.61 1.61 0 0 0 0 3.218 1.61 1.61 0 0 0 0-3.218Zm0 .969a.64.64 0 0 1 0 1.28.64.64 0 0 1 0-1.28Z"
        ],
        "yelp": [
            "M12.1 10.638c-.053-1.26-.426-6.877-.47-7.138-.064-.235-.245-.403-.506-.47-.799-.202-3.854.669-4.421 1.263-.182.192-.25.43-.195.64.088.186 3.876 6.239 3.876 6.239.56.922 1.016.78 1.166.732.15-.048.602-.192.55-1.266Zm3.146 2.628c3.132-.77 3.253-.812 3.377-.895.19-.128.284-.346.268-.61v-.029c-.08-.78-1.428-2.814-2.092-3.143-.235-.115-.471-.107-.665.025-.12.08-.21.202-1.887 2.531l-.767 1.06c-.2.246-.202.6-.008.904.202.314.544.467.857.379 0 0-.013.022-.017.026.155-.06.432-.128.934-.25Zm3.745 3.95c-.106.755-1.626 2.718-2.322 3-.241.099-.473.075-.654-.07-.118-.094-.243-.285-1.88-2.985l-.487-.805c-.186-.288-.15-.668.083-.957.224-.283.56-.388.851-.273.016.007 1.225.413 1.225.413 2.755.919 2.846.954 2.962 1.043.178.144.259.371.222.634Zm-7.005 4.024c.049-.14.054-.238.062-3.182l.008-1.314c.02-.318-.183-.608-.516-.74-.343-.133-.711-.05-.918.213 0 0-.604.729-.607.729-2.077 2.477-2.162 2.591-2.213 2.738a.596.596 0 0 0-.032.27c.012.131.07.262.167.382.481.582 2.79 1.446 3.527 1.318.257-.048.443-.194.522-.414Zm-6.951-6.222c-.102-1.015.023-2.546.322-3.031.14-.225.344-.342.573-.333.15.002.282.05 3.246 1.293l.865.358c.313.119.504.45.484.823-.02.365-.226.651-.531.73l-1.231.399c-2.758.901-2.85.927-2.996.918-.229-.007-.43-.145-.55-.375-.085-.167-.145-.446-.182-.782Z"
        ],
        "youtube": [
            "M19.825 5.428a2.507 2.507 0 0 1 1.763 1.763c.428 1.565.412 4.827.412 4.827s0 3.245-.412 4.81a2.506 2.506 0 0 1-1.763 1.763c-1.565.412-7.825.412-7.825.412s-6.244 0-7.825-.428a2.506 2.506 0 0 1-1.763-1.763C2 15.263 2 12.002 2 12.002s0-3.246.412-4.81a2.557 2.557 0 0 1 1.763-1.78C5.74 5 12 5 12 5s6.26 0 7.825.428Zm-9.818 3.575V15l5.206-2.998-5.206-2.999Z"
        ]
    }
};

const iconClassMap = getInvertedClassMap(styles);
const sizesClassMap = getInvertedClassMap(sizes);
const colorsClassMap = getInvertedClassMap(colors);
function getInvertedClassMap(classMap) {
    return Object.keys(classMap).reduce((acc, value) => (Object.assign(Object.assign({}, acc), { [classMap[value]]: value })), {});
}
function getIcon({ name, color, size = "base" }) {
    const svgClassNames = classnames(styles.icon, sizes[size], {
        [styles.longArrowUp]: name === "longArrowUp",
        [styles.longArrowDown]: name === "longArrowDown",
        [styles.longArrowRight]: name === "longArrowRight",
        [styles.longArrowLeft]: name === "longArrowLeft",
        [styles.thumbsDown]: name === "thumbsDown",
        [styles.runningTimer]: name === "runningTimer",
    });
    const pathClassNames = getPathClassNames(name, color);
    const paths = getPaths(name);
    const iconSize = name === "truck" ? 1024 : 24;
    const viewBox = `0 0 ${iconSize} ${iconSize}`;
    return { svgClassNames, pathClassNames, paths, viewBox };
}
function getPaths(name) {
    const iconName = mapToCorrectIcon(name);
    if (iconName === "truck") {
        return [];
    }
    else {
        return iconMap.icons[iconName];
    }
}
function mapToCorrectIcon(name) {
    switch (name) {
        case "longArrowUp":
            return "backArrow";
        case "longArrowDown":
            return "backArrow";
        case "longArrowRight":
            return "backArrow";
        case "longArrowLeft":
            return "backArrow";
        case "remove":
            return "cross";
        case "thumbsDown":
            return "thumbsUp";
        default:
            return name;
    }
}
function getPathClassNames(name, color) {
    return classnames(color && colors[color], {
        [styles.person]: name === "person",
        [styles.clients]: name === "clients",
        [styles.company]: name === "company",
        [styles.property]: name === "property",
        [styles.userUnassigned]: name === "userUnassigned",
        [styles.job]: name === "job",
        [styles.jobOnHold]: name === "jobOnHold",
        [styles.visit]: name === "visit",
        [styles.moveVisits]: name === "moveVisits",
        [styles.event]: name === "event",
        [styles.request]: name === "request",
        [styles.reminder]: name === "reminder",
        [styles.trash]: name === "trash",
        [styles.task]: name === "task",
        [styles.timer]: name === "timer" || name === "runningTimer",
        [styles.quote]: name === "quote",
        [styles.invoice]: name === "invoice",
        [styles.checkmark]: name === "checkmark",
        [styles.invoiceLater]: name === "invoiceLater",
        [styles.badInvoice]: name === "badInvoice",
        [styles.sendInvoice]: name === "sendInvoice",
        [styles.paidInvoice]: name === "paidInvoice",
        [styles.payment]: name === "payment",
        [styles.expense]: name === "expense",
        [styles.excel]: name === "excel",
        [styles.pdf]: name === "pdf",
        [styles.word]: name === "word",
        [styles.video]: name === "video",
    });
}

/* This file is automatically generated by buildIconStyle.js and should not be edited. */
const iconStyles = {
    "icon": {
        "fill": "hsl(198, 35%, 21%)",
        "display": "inline-block",
        "verticalAlign": "middle"
    },
    "longArrowUp": {
        "transform": [
            {
                "rotate": "90deg"
            }
        ]
    },
    "longArrowDown": {
        "transform": [
            {
                "rotate": "-90deg"
            }
        ]
    },
    "longArrowRight": {
        "transform": [
            {
                "rotate": "180deg"
            }
        ]
    },
    "longArrowLeft": {
        "transform": [
            {
                "rotate": "0deg"
            }
        ]
    },
    "thumbsDown": {
        "transform": [
            {
                "scaleY": -1
            }
        ]
    },
    "person": {
        "fill": "hsl(48, 3%, 34%)"
    },
    "clients": {
        "fill": "hsl(48, 3%, 34%)"
    },
    "company": {
        "fill": "hsl(48, 3%, 34%)"
    },
    "property": {
        "fill": "hsl(48, 3%, 34%)"
    },
    "job": {
        "fill": "hsl(107, 58%, 33%)"
    },
    "jobOnHold": {
        "fill": "hsl(107, 58%, 33%)"
    },
    "visit": {
        "fill": "hsl(79, 85%, 34%)"
    },
    "moveVisits": {
        "fill": "hsl(79, 85%, 34%)"
    },
    "event": {
        "fill": "hsl(51, 64%, 49%)"
    },
    "quote": {
        "fill": "hsl(348, 40%, 41%)"
    },
    "request": {
        "fill": "hsl(33, 71%, 38%)"
    },
    "task": {
        "fill": "hsl(207, 61%, 34%)"
    },
    "userUnassigned": {
        "fill": "hsl(6, 64%, 51%)"
    },
    "reminder": {
        "fill": "hsl(6, 64%, 51%)"
    },
    "trash": {
        "fill": "hsl(6, 64%, 51%)"
    },
    "checkmark": {
        "fill": "hsl(107, 58%, 33%)"
    },
    "timer": {
        "fill": "hsl(207, 79%, 57%)"
    },
    "invoice": {
        "fill": "hsl(207, 61%, 34%)"
    },
    "invoiceLater": {
        "fill": "hsl(207, 61%, 34%)"
    },
    "sendInvoice": {
        "fill": "hsl(207, 61%, 34%)"
    },
    "paidInvoice": {
        "fill": "hsl(207, 61%, 34%)"
    },
    "badInvoice": {
        "fill": "hsl(6, 64%, 51%)"
    },
    "payment": {
        "fill": "hsl(33, 71%, 48%)"
    },
    "expense": {
        "fill": "hsl(33, 71%, 48%)"
    },
    "video": {
        "fill": "hsl(207, 79%, 57%)"
    },
    "excel": {
        "fill": "rgb(31, 115, 71)"
    },
    "pdf": {
        "fill": "rgb(195, 27, 0)"
    },
    "word": {
        "fill": "rgb(41, 86, 154)"
    },
    "runningTimer": {
        "animationDuration": "5s",
        "animationIterationCount": "infinite",
        "animationName": "spinning",
        "animationTimingFunction": "linear"
    },
    "small": {
        "width": 16,
        "height": 16
    },
    "base": {
        "width": 24,
        "height": 24
    },
    "large": {
        "width": 32,
        "height": 32
    },
    "white": {
        "fill": "rgba(255, 255, 255, 1)"
    },
    "grey": {
        "fill": "hsl(0, 0%, 72%)"
    },
    "greyBlue": {
        "fill": "hsl(197, 15%, 45%)"
    },
    "greyBlueDark": {
        "fill": "hsl(198, 35%, 21%)"
    },
    "greyBlueLighter": {
        "fill": "hsl(196, 12%, 70%)"
    },
    "blue": {
        "fill": "hsl(197, 90%, 12%)"
    },
    "lightBlue": {
        "fill": "hsl(207, 79%, 57%)"
    },
    "green": {
        "fill": "hsl(107, 58%, 33%)"
    },
    "yellow": {
        "fill": "hsl(51, 64%, 49%)"
    },
    "red": {
        "fill": "hsl(6, 64%, 51%)"
    },
    "navy": {
        "fill": "hsl(207, 61%, 34%)"
    },
    "orange": {
        "fill": "hsl(33, 71%, 48%)"
    },
    "interactive": {
        "fill": "hsl(107, 58%, 33%)"
    },
    "interactiveHover": {
        "fill": "hsl(107, 65%, 24%)"
    },
    "destructive": {
        "fill": "hsl(6, 64%, 51%)"
    },
    "destructiveHover": {
        "fill": "hsl(6, 100%, 35%)"
    },
    "interactiveSubtle": {
        "fill": "hsl(198, 35%, 21%)"
    },
    "interactiveSubtleHover": {
        "fill": "hsl(197, 90%, 12%)"
    },
    "disabled": {
        "fill": "hsl(0, 0%, 72%)"
    },
    "disabledSecondary": {
        "fill": "hsl(0, 0%, 93%)"
    },
    "focus": {
        "fill": "hsl(198, 12%, 57%)"
    },
    "critical": {
        "fill": "hsl(6, 64%, 51%)"
    },
    "criticalSurface": {
        "fill": "hsl(7, 63%, 95%)"
    },
    "criticalOnSurface": {
        "fill": "hsl(6, 100%, 24%)"
    },
    "warning": {
        "fill": "hsl(51, 64%, 49%)"
    },
    "warningSurface": {
        "fill": "hsl(52, 64%, 89%)"
    },
    "warningOnSurface": {
        "fill": "hsl(51, 64%, 24%)"
    },
    "success": {
        "fill": "hsl(107, 58%, 33%)"
    },
    "successSurface": {
        "fill": "hsl(109, 28%, 92%)"
    },
    "successOnSurface": {
        "fill": "hsl(107, 64%, 16%)"
    },
    "informative": {
        "fill": "hsl(207, 79%, 57%)"
    },
    "informativeSurface": {
        "fill": "hsl(207, 87%, 94%)"
    },
    "informativeOnSurface": {
        "fill": "hsl(207, 61%, 34%)"
    },
    "inactive": {
        "fill": "hsl(198, 25%, 33%)"
    },
    "inactiveSurface": {
        "fill": "hsl(195, 12%, 94%)"
    },
    "inactiveOnSurface": {
        "fill": "hsl(197, 90%, 12%)"
    },
    "heading": {
        "fill": "hsl(197, 90%, 12%)"
    },
    "text": {
        "fill": "hsl(198, 35%, 21%)"
    },
    "textSecondary": {
        "fill": "hsl(197, 15%, 45%)"
    },
    "textReverse": {
        "fill": "rgba(255, 255, 255, 1)"
    },
    "textReverseSecondary": {
        "fill": "hsl(200, 13%, 87%)"
    },
    "surface": {
        "fill": "rgba(255, 255, 255, 1)"
    },
    "surfaceHover": {
        "fill": "hsl(53, 21%, 93%)"
    },
    "surfaceActive": {
        "fill": "hsl(51, 17%, 85%)"
    },
    "surfaceBackground": {
        "fill": "hsl(53, 21%, 93%)"
    },
    "surfaceReverse": {
        "fill": "hsl(197, 90%, 12%)"
    },
    "brand": {
        "fill": "hsl(79, 85%, 34%)"
    },
    "brandHighlight": {
        "fill": "hsl(86, 100%, 46%)"
    }
};

/* tslint:disable */
/* eslint-disable */
/* This file is automatically generated and should not be edited. */
const tokens = {
  "border-base": 1,
  "border-thick": 2,
  "border-thicker": 4,
  "border-thickest": 8,
  "color-interactive": "hsl(107, 58%, 33%)",
  "color-interactive--hover": "hsl(107, 65%, 24%)",
  "color-destructive": "hsl(6, 64%, 51%)",
  "color-destructive--hover": "hsl(6, 100%, 35%)",
  "color-interactive--subtle": "hsl(198, 35%, 21%)",
  "color-interactive--subtle--hover": "hsl(197, 90%, 12%)",
  "color-disabled": "hsl(0, 0%, 72%)",
  "color-disabled--secondary": "hsl(0, 0%, 93%)",
  "color-focus": "hsl(198, 12%, 57%)",
  "color-critical": "hsl(6, 64%, 51%)",
  "color-critical--surface": "hsl(7, 63%, 95%)",
  "color-critical--onSurface": "hsl(6, 100%, 24%)",
  "color-warning": "hsl(51, 64%, 49%)",
  "color-warning--surface": "hsl(52, 64%, 89%)",
  "color-warning--onSurface": "hsl(51, 64%, 24%)",
  "color-success": "hsl(107, 58%, 33%)",
  "color-success--surface": "hsl(109, 28%, 92%)",
  "color-success--onSurface": "hsl(107, 64%, 16%)",
  "color-informative": "hsl(207, 79%, 57%)",
  "color-informative--surface": "hsl(207, 87%, 94%)",
  "color-informative--onSurface": "hsl(207, 61%, 34%)",
  "color-inactive": "hsl(198, 25%, 33%)",
  "color-inactive--surface": "hsl(195, 12%, 94%)",
  "color-inactive--onSurface": "hsl(197, 90%, 12%)",
  "color-heading": "hsl(197, 90%, 12%)",
  "color-text": "hsl(198, 35%, 21%)",
  "color-text--secondary": "hsl(197, 15%, 45%)",
  "color-text--reverse": "rgba(255, 255, 255, 1)",
  "color-text--reverse--secondary": "hsl(200, 13%, 87%)",
  "color-icon": "hsl(198, 35%, 21%)",
  "color-surface": "rgba(255, 255, 255, 1)",
  "color-surface--hover": "hsl(53, 21%, 93%)",
  "color-surface--background": "hsl(53, 21%, 93%)",
  "color-surface--background--hover": "hsl(51, 17%, 85%)",
  "color-surface--background--subtle": "hsl(45, 20%, 97%)",
  "color-surface--background--subtle--hover": "hsl(51, 17%, 85%)",
  "color-surface--reverse": "hsl(197, 90%, 12%)",
  "color-surface--active": "hsl(51, 17%, 85%)",
  "color-border": "hsl(200, 13%, 87%)",
  "color-border--interactive": "hsl(198, 12%, 57%)",
  "color-border--section": "hsl(197, 90%, 12%)",
  "color-overlay": "rgba(0, 0, 0, 0.32)",
  "color-overlay--dimmed": "rgba(255, 255, 255, 0.6)",
  "color-brand": "hsl(79, 85%, 34%)",
  "color-brand--highlight": "hsl(86, 100%, 46%)",
  "color-request": "hsl(33, 71%, 38%)",
  "color-request--surface": "hsl(34, 76%, 92%)",
  "color-request--onSurface": "hsl(33, 72%, 20%)",
  "color-quote": "hsl(348, 40%, 41%)",
  "color-quote--surface": "hsl(347, 33%, 95%)",
  "color-quote--onSurface": "hsl(348, 40%, 27%)",
  "color-job": "hsl(107, 58%, 33%)",
  "color-job--surface": "hsl(109, 28%, 92%)",
  "color-job--onSurface": "hsl(107, 65%, 24%)",
  "color-task": "hsl(206, 61%, 23%)",
  "color-task--surface": "hsl(195, 12%, 94%)",
  "color-task--onSurface": "hsl(198, 35%, 21%)",
  "color-invoice": "hsl(207, 61%, 34%)",
  "color-invoice--surface": "hsl(207, 87%, 94%)",
  "color-invoice--onSurface": "hsl(206, 61%, 23%)",
  "color-visit": "hsl(107, 58%, 33%)",
  "color-visit--surface": "hsl(109, 28%, 92%)",
  "color-visit--onSurface": "hsl(107, 65%, 24%)",
  "color-event": "hsl(51, 64%, 49%)",
  "color-event--surface": "hsl(52, 64%, 89%)",
  "color-event--onSurface": "hsl(51, 64%, 24%)",
  "color-payments": "hsl(207, 61%, 34%)",
  "color-payments--surface": "hsl(207, 87%, 94%)",
  "color-payments--onSurface": "hsl(207, 87%, 94%)",
  "color-client": "hsl(48, 3%, 34%)",
  "color-blue": "hsl(197, 90%, 12%)",
  "color-blue--light": "hsl(198, 25%, 33%)",
  "color-blue--lighter": "hsl(198, 12%, 57%)",
  "color-blue--lightest": "hsl(200, 13%, 87%)",
  "color-blue--dark": "hsl(198, 96%, 9%)",
  "color-taupe": "hsl(53, 21%, 93%)",
  "color-taupe--light": "hsl(45, 20%, 97%)",
  "color-taupe--dark": "hsl(51, 17%, 85%)",
  "color-green": "hsl(107, 58%, 33%)",
  "color-green--light": "hsl(107, 30%, 49%)",
  "color-green--lighter": "hsl(107, 29%, 65%)",
  "color-green--lightest": "hsl(109, 28%, 92%)",
  "color-green--dark": "hsl(107, 64%, 16%)",
  "color-lime": "hsl(79, 85%, 34%)",
  "color-lime--light": "hsl(79, 51%, 51%)",
  "color-lime--lighter": "hsl(79, 51%, 78%)",
  "color-lime--lightest": "hsl(79, 49%, 90%)",
  "color-lime--dark": "hsl(79, 85%, 21%)",
  "color-yellowGreen": "hsl(79, 85%, 34%)",
  "color-yellowGreen--light": "hsl(79, 51%, 51%)",
  "color-yellowGreen--lighter": "hsl(79, 51%, 78%)",
  "color-yellowGreen--lightest": "hsl(79, 49%, 90%)",
  "color-yellowGreen--dark": "hsl(79, 86%, 27%)",
  "color-yellow": "hsl(51, 64%, 49%)",
  "color-yellow--light": "hsl(51, 64%, 77%)",
  "color-yellow--lighter": "hsl(52, 64%, 89%)",
  "color-yellow--lightest": "hsl(49, 67%, 95%)",
  "color-yellow--dark": "hsl(51, 64%, 32%)",
  "color-red": "hsl(6, 64%, 51%)",
  "color-red--light": "hsl(6, 64%, 76%)",
  "color-red--lighter": "hsl(5, 65%, 90%)",
  "color-red--lightest": "hsl(7, 63%, 95%)",
  "color-red--dark": "hsl(6, 100%, 24%)",
  "color-grey": "hsl(0, 0%, 72%)",
  "color-grey--light": "hsl(0, 0%, 87%)",
  "color-grey--lighter": "hsl(0, 0%, 93%)",
  "color-grey--lightest": "hsl(0, 0%, 97%)",
  "color-grey--dark": "hsl(0, 0%, 47%)",
  "color-greyBlue--rgb": "101, 120, 132",
  "color-greyBlue": "hsl(197, 15%, 45%)",
  "color-greyBlue--light": "hsl(198, 12%, 57%)",
  "color-greyBlue--lighter": "hsl(196, 12%, 70%)",
  "color-greyBlue--lightest": "hsl(195, 12%, 94%)",
  "color-greyBlue--dark": "hsl(198, 35%, 21%)",
  "color-lightBlue": "hsl(207, 79%, 57%)",
  "color-lightBlue--light": "hsl(207, 89%, 71%)",
  "color-lightBlue--lighter": "hsl(206, 91%, 87%)",
  "color-lightBlue--lightest": "hsl(207, 87%, 94%)",
  "color-lightBlue--dark": "hsl(207, 61%, 45%)",
  "color-purple": "hsl(348, 40%, 27%)",
  "color-purple--light": "rgb(172, 155, 214)",
  "color-purple--lighter": "rgb(207, 198, 231)",
  "color-purple--lightest": "rgb(237, 234, 246)",
  "color-purple--dark": "hsl(347, 41%, 18%)",
  "color-pink": "hsl(348, 34%, 53%)",
  "color-pink--light": "hsl(349, 34%, 64%)",
  "color-pink--lighter": "hsl(349, 34%, 75%)",
  "color-pink--lightest": "hsl(347, 33%, 95%)",
  "color-pink--dark": "hsl(348, 40%, 27%)",
  "color-teal": "rgb(62, 173, 146)",
  "color-teal--light": "rgb(120, 198, 179)",
  "color-teal--lighter": "rgb(178, 222, 211)",
  "color-teal--lightest": "rgb(226, 243, 239)",
  "color-teal--dark": "rgb(40, 112, 95)",
  "color-orange": "hsl(33, 71%, 48%)",
  "color-orange--light": "hsl(33, 77%, 63%)",
  "color-orange--lighter": "hsl(32, 78%, 84%)",
  "color-orange--lightest": "hsl(34, 76%, 92%)",
  "color-orange--dark": "hsl(33, 71%, 38%)",
  "color-brown": "hsl(33, 71%, 29%)",
  "color-brown--light": "hsl(33, 71%, 38%)",
  "color-brown--lighter": "hsl(51, 17%, 85%)",
  "color-brown--dark": "hsl(33, 72%, 20%)",
  "color-navy": "hsl(207, 61%, 34%)",
  "color-navy--light": "hsl(207, 61%, 45%)",
  "color-navy--lighter": "hsl(200, 13%, 87%)",
  "color-navy--lightest": "hsl(195, 12%, 94%)",
  "color-navy--dark": "hsl(206, 61%, 23%)",
  "color-indigo": "rgb(85, 106, 203)",
  "color-indigo--light": "rgb(136, 151, 219)",
  "color-indigo--lighter": "rgb(187, 195, 234)",
  "color-indigo--lightest": "rgb(230, 233, 247)",
  "color-indigo--dark": "rgb(55, 69, 132)",
  "color-white--rgb": "255, 255, 255",
  "color-white": "rgba(255, 255, 255, 1)",
  "color-base-white": "rgba(255, 255, 255, 1)",
  "color-base-grey--100": "hsl(0, 0%, 97%)",
  "color-base-grey--200": "hsl(0, 0%, 93%)",
  "color-base-grey--300": "hsl(0, 0%, 87%)",
  "color-base-grey--400": "hsl(0, 0%, 72%)",
  "color-base-grey--500": "hsl(0, 0%, 58%)",
  "color-base-grey--600": "hsl(0, 0%, 47%)",
  "color-base-grey--700": "hsl(0, 0%, 35%)",
  "color-base-grey--800": "hsl(0, 0%, 24%)",
  "color-base-grey--900": "hsl(0, 0%, 15%)",
  "color-base-grey--1000": "hsl(0, 0%, 11%)",
  "color-black--rgb": "0, 0, 0",
  "color-black": "rgba(0, 0, 0, 1)",
  "color-base-black": "rgba(0, 0, 0, 1)",
  "color-base-taupe--100": "hsl(45, 20%, 97%)",
  "color-base-taupe--200": "hsl(53, 21%, 93%)",
  "color-base-taupe--300": "hsl(51, 17%, 85%)",
  "color-base-taupe--400": "hsl(49, 7%, 70%)",
  "color-base-taupe--500": "hsl(47, 4%, 57%)",
  "color-base-taupe--600": "hsl(43, 3%, 46%)",
  "color-base-taupe--700": "hsl(48, 3%, 34%)",
  "color-base-taupe--800": "hsl(40, 3%, 23%)",
  "color-base-taupe--900": "hsl(30, 3%, 15%)",
  "color-base-taupe--1000": "hsl(30, 4%, 11%)",
  "color-base-red--100": "hsl(10, 60%, 98%)",
  "color-base-red--200": "hsl(7, 63%, 95%)",
  "color-base-red--300": "hsl(5, 65%, 90%)",
  "color-base-red--400": "hsl(6, 64%, 76%)",
  "color-base-red--500": "hsl(6, 64%, 65%)",
  "color-base-red--600": "hsl(6, 64%, 51%)",
  "color-base-red--700": "hsl(6, 100%, 35%)",
  "color-base-red--800": "hsl(6, 100%, 24%)",
  "color-base-red--900": "hsl(6, 100%, 16%)",
  "color-base-red--1000": "hsl(6, 100%, 12%)",
  "color-base-green--100": "hsl(108, 29%, 97%)",
  "color-base-green--200": "hsl(109, 28%, 92%)",
  "color-base-green--300": "hsl(106, 28%, 85%)",
  "color-base-green--400": "hsl(107, 29%, 65%)",
  "color-base-green--500": "hsl(107, 30%, 49%)",
  "color-base-green--600": "hsl(107, 58%, 33%)",
  "color-base-green--700": "hsl(107, 65%, 24%)",
  "color-base-green--800": "hsl(107, 64%, 16%)",
  "color-base-green--900": "hsl(108, 63%, 11%)",
  "color-base-green--1000": "hsl(108, 64%, 8%)",
  "color-base-blue--100": "hsl(210, 17%, 98%)",
  "color-base-blue--200": "hsl(195, 12%, 94%)",
  "color-base-blue--300": "hsl(200, 13%, 87%)",
  "color-base-blue--400": "hsl(196, 12%, 70%)",
  "color-base-blue--500": "hsl(198, 12%, 57%)",
  "color-base-blue--600": "hsl(197, 15%, 45%)",
  "color-base-blue--700": "hsl(198, 25%, 33%)",
  "color-base-blue--800": "hsl(198, 35%, 21%)",
  "color-base-blue--900": "hsl(197, 90%, 12%)",
  "color-base-blue--1000": "hsl(198, 96%, 9%)",
  "color-base-yellow--100": "hsl(49, 67%, 95%)",
  "color-base-yellow--200": "hsl(52, 64%, 89%)",
  "color-base-yellow--300": "hsl(51, 64%, 77%)",
  "color-base-yellow--400": "hsl(51, 64%, 49%)",
  "color-base-yellow--500": "hsl(51, 64%, 40%)",
  "color-base-yellow--600": "hsl(51, 64%, 32%)",
  "color-base-yellow--700": "hsl(51, 64%, 24%)",
  "color-base-yellow--800": "hsl(51, 64%, 16%)",
  "color-base-yellow--900": "hsl(51, 63%, 11%)",
  "color-base-yellow--1000": "hsl(50, 64%, 8%)",
  "color-base-lime--100": "hsl(80, 53%, 97%)",
  "color-base-lime--200": "hsl(79, 49%, 90%)",
  "color-base-lime--300": "hsl(79, 51%, 78%)",
  "color-base-lime--400": "hsl(79, 51%, 51%)",
  "color-base-lime--500": "hsl(79, 85%, 34%)",
  "color-base-lime--600": "hsl(79, 86%, 27%)",
  "color-base-lime--700": "hsl(79, 85%, 21%)",
  "color-base-lime--800": "hsl(79, 86%, 14%)",
  "color-base-lime--900": "hsl(78, 87%, 9%)",
  "color-base-lime--1000": "hsl(79, 82%, 7%)",
  "color-base-lightBlue--100": "hsl(205, 86%, 97%)",
  "color-base-lightBlue--200": "hsl(207, 87%, 94%)",
  "color-base-lightBlue--300": "hsl(206, 91%, 87%)",
  "color-base-lightBlue--400": "hsl(207, 89%, 71%)",
  "color-base-lightBlue--500": "hsl(207, 79%, 57%)",
  "color-base-lightBlue--600": "hsl(207, 61%, 45%)",
  "color-base-lightBlue--700": "hsl(207, 61%, 34%)",
  "color-base-lightBlue--800": "hsl(206, 61%, 23%)",
  "color-base-lightBlue--900": "hsl(207, 61%, 15%)",
  "color-base-lightBlue--1000": "hsl(207, 60%, 11%)",
  "color-base-pink--100": "hsl(345, 40%, 98%)",
  "color-base-pink--200": "hsl(347, 33%, 95%)",
  "color-base-pink--300": "hsl(348, 36%, 89%)",
  "color-base-pink--400": "hsl(349, 34%, 75%)",
  "color-base-pink--500": "hsl(349, 34%, 64%)",
  "color-base-pink--600": "hsl(348, 34%, 53%)",
  "color-base-pink--700": "hsl(348, 40%, 41%)",
  "color-base-pink--800": "hsl(348, 40%, 27%)",
  "color-base-pink--900": "hsl(347, 41%, 18%)",
  "color-base-pink--1000": "hsl(349, 40%, 13%)",
  "color-base-orange--100": "hsl(36, 71%, 97%)",
  "color-base-orange--200": "hsl(34, 76%, 92%)",
  "color-base-orange--300": "hsl(32, 78%, 84%)",
  "color-base-orange--400": "hsl(33, 77%, 63%)",
  "color-base-orange--500": "hsl(33, 71%, 48%)",
  "color-base-orange--600": "hsl(33, 71%, 38%)",
  "color-base-orange--700": "hsl(33, 71%, 29%)",
  "color-base-orange--800": "hsl(33, 72%, 20%)",
  "color-base-orange--900": "hsl(33, 72%, 13%)",
  "color-base-orange--1000": "hsl(33, 70%, 9%)",
  "radius-small": 4,
  "radius-base": 8,
  "radius-large": 16,
  "radius-larger": 24,
  "radius-circle": 100,
  "base-unit": 16,
  "space-minuscule": 1,
  "space-smallest": 2,
  "space-smaller": 4,
  "space-small": 8,
  "space-base": 16,
  "space-large": 24,
  "space-larger": 32,
  "space-largest": 48,
  "space-extravagant": 64,
  "timing-quick": 100,
  "timing-base": 200,
  "timing-slow": 300,
  "timing-slower": 400,
  "timing-slowest": 500,
  "timing-loading": 1000,
  "timing-loading--extended": 2000,
  "opacity-overlay": 0.8,
  "opacity-pressed": 0.6,
  "elevation-default": 0,
  "elevation-base": 1,
  "elevation-menu": 6,
  "elevation-datepicker": 6,
  "elevation-modal": 1001,
  "elevation-tooltip": 1002,
  "elevation-toast": 1003,
  "typography--letterSpacing-base": 0,
  "typography--letterSpacing-loose": 0.4,
  "typography--fontFamily-normal": "\"Inter\", Helvetica, Arial, sans-serif",
  "typography--fontFamily-display": "\"Jobber Pro\", \"Poppins\", Helvetica, Arial,    sans-serif",
  "typography--fontSize-extravagant": 48,
  "typography--fontSize-jumbo": 36,
  "typography--fontSize-largest": 24,
  "typography--fontSize-larger": 20,
  "typography--fontSize-large": 16,
  "typography--fontSize-base": 14,
  "typography--fontSize-small": 12,
  "typography--fontSize-smaller": 10,
  "typography--lineHeight-large": 1.34,
  "typography--lineHeight-base": 1.25,
  "typography--lineHeight-tight": 1.2,
  "typography--lineHeight-tighter": 1.143,
  "typography--lineHeight-tightest": 1.12,
  "typography--lineHeight-miniscule": 1.08
};

exports.colorsClassMap = colorsClassMap;
exports.getIcon = getIcon;
exports.iconClassMap = iconClassMap;
exports.iconStyles = iconStyles;
exports.sizesClassMap = sizesClassMap;
exports.tokens = tokens;
